<template>
  <div>
    <tahsilatdialog1 ref="tahsilatdialog1" v-model="BiletAyrintiliOdeme"></tahsilatdialog1>
    <v-form>
      <v-card flat="">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Bilet Satış </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn @click="biletkaydet()" v-if="kaydetbuton" class="white--text" flat> <span
                  class="hidden-sm-and-down">
                  Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>


              <v-btn v-if="guncellebtngorunum" @click="biletkaydet()" :disabled="guncellebuton" class="white--text"
                flat> <span class="hidden-sm-and-down"> Güncelle </span>
                <v-icon right dark>create</v-icon>
              </v-btn>

              <v-btn v-if="voidiptalbtn" @click="voidiptal()" class="white--text" flat> <span
                  class="hidden-sm-and-down">
                  Void İptal </span>
                <v-icon right dark>clear</v-icon>
              </v-btn>
              <v-btn @click="biletyazdir()" v-if="faturanovarise" icon>
                <v-icon>print</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile v-if="voidbtn" @click="voidyap()">
                    <v-list-tile-title>Void Yap</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile v-if="voidiptalbtn" @click="voidiptal()">
                    <v-list-tile-title>Void İptal</v-list-tile-title>
                  </v-list-tile> -->
                  <v-list-tile :disabled="faturabtn" @click="faturadialogac()">
                    <v-list-tile-title>Fatura</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="iadebtn" @click="yeniiadeekle()">
                    <v-list-tile-title>İade Ekle</v-list-tile-title>
                  </v-list-tile>



                </v-list>
              </v-menu>

              <!-- <v-btn v-if="voidbtn" @click="voidyap()" :disabled="voiddurum" class="white--text" flat>Voİd Yap
                <v-icon right dark>find_replace</v-icon>
              </v-btn>
              <v-btn @click="voidiptal()" v-if="voidiptalbtn" class="white--text" flat>Void İptal
                <v-icon right dark>find_replace</v-icon>
              </v-btn> -->
            </v-toolbar>
          </v-flex>
          <v-layout>
            <v-flex sm12 md12>
              <v-card>
                <v-list two-line>
                  <v-layout row wrap>
                    <v-flex sm12 md1>
                      <v-card flat="">
                        <v-list-tile>
                          <v-img :src="getImgUrl(Bilet.GenelBilgileri.HavaYoluKodu)" height="100%" width="100%" contain>
                          </v-img>
                        </v-list-tile>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm4 md6>
                      <v-layout align-start justify-start row fill-height>
                        <v-card flat="">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout row align-center justify-start>
                                <div class="font-weight-bold grey--text subheading ">
                                  <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='I'" small color="green"
                                    text-color="white">İç
                                    Hat</v-chip>
                                  <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='D'" small color="info"
                                    text-color="white">Dış
                                    Hat</v-chip>
                                  <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='B'" small color="orange"
                                    text-color="white">BSP</v-chip>
                                  -{{Bilet.GenelBilgileri.Formno}}-{{Bilet.GenelBilgileri.BiletNo}}-{{Bilet.GenelBilgileri.HavaYoluKodu}}
                                  <v-chip v-if="faturanovarise" small color="orange" text-color="white">Fatura
                                    Edilmiştir</v-chip>
                                  <div class="font-weight-bold red--text subheading ">{{baslik_mesaji}} </div>
                                </div>
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-card>
                      </v-layout>
                    </v-flex>



                    <v-flex xs12 sm4 md2>
                      <v-layout justify-center="" align-center="" fill-height="">


                      </v-layout>

                    </v-flex>

                  </v-layout>
                </v-list>
              </v-card>
            </v-flex>

          </v-layout>
          <v-tabs v-if="bekletme" style="width:100%; height:100%" dark="" v-model="active" color="info" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              Genel
            </v-tab>

            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-layout v-if="tabviewgenel" row="" style="padding-top:10px;" wrap="">
                <v-flex xs12 sm12 md4 style="padding-right:10px;">
                  <v-layout column>
                    <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                      <v-card class="white--text">
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-autocomplete hide-details tabindex="1" append-icon="search" label="Cari Seçiniz"
                                  :loading="loading" :items="statecari" clearable="" item-text="text" cache-items=""
                                  item-value="id" :search-input.sync="searchcari"
                                  v-model="Bilet.GenelBilgileri.MusteriKodu.Kod"></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight-bold grey--text mb-2">
                                  {{Bilet.GenelBilgileri.MusteriKodu.Unvan}} </span>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <span class="body-1 font-weight grey--text mb-2"> Kredi Limiti :{{KrediLimiti}}
                                  ₺ </span>
                                {{Bilet.TanimBilgileri.ExAciklamalar.EmployeeId}}
                              </v-flex>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                      <v-card class="white--text">
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <musteribilgipart :yolcuadi="yolcudisabled" v-model="Bilet.GenelBilgileri">
                                </musteribilgipart>
                              </v-flex>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                      <v-card class="white--text">
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout row wrap>

                              <v-flex xs12 sm6 md6>
                                <v-layout justify-space-between column>
                                  <v-layout>
                                    <v-flex xs12 sm6 md6>
                                      <parkurcomp :tabindex="7" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur1">
                                      </parkurcomp>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-autocomplete :items="classitems" tabindex="12" hide-details="" clearable
                                        v-model="Bilet.GenelBilgileri.Classlar.Class1" item-text="ClassAdi"
                                        item-value="ClassAdi" label="Class"></v-autocomplete>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs12 sm6 md6>
                                      <parkurcomp :tabindex="'8'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur2">
                                      </parkurcomp>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-autocomplete :items="classitems" tabindex="13" hide-details=""
                                        v-model="Bilet.GenelBilgileri.Classlar.Class2" item-text="ClassAdi"
                                        item-value="ClassAdi" clearable label="Class"></v-autocomplete>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs12 sm6 md6>
                                      <parkurcomp :tabindex="'9'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur3">
                                      </parkurcomp>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-autocomplete :items="classitems" hide-details=""
                                        v-model="Bilet.GenelBilgileri.Classlar.Class3" item-text="ClassAdi"
                                        item-value="ClassAdi" tabindex="14" clearable label="Class"></v-autocomplete>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs12 sm6 md6>
                                      <parkurcomp :tabindex="'10'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur4">
                                      </parkurcomp>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-autocomplete :items="classitems" hide-details=""
                                        v-model="Bilet.GenelBilgileri.Classlar.Class4" item-text="ClassAdi"
                                        item-value="ClassAdi" tabindex="15" clearable label="Class"></v-autocomplete>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs12 sm6 md6>
                                      <parkurcomp :tabindex="'11'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur5">
                                      </parkurcomp>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-autocomplete :items="classitems" hide-details=""
                                        v-model="Bilet.GenelBilgileri.Classlar.Class5" item-text="ClassAdi"
                                        item-value="ClassAdi" tabindex="16" clearable label="Class"></v-autocomplete>
                                    </v-flex>
                                  </v-layout>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-layout justify-space-between column>
                                  <tarihim :etiket="'Gidiş Tarihi'" :tabindex="'17'"
                                    v-bind:value="Bilet.UcusBilgileri.UcusTarihi"
                                    v-model="Bilet.UcusBilgileri.UcusTarihi"></tarihim>

                                  <v-layout>
                                    <v-text-field hide-details="" :tabindex="'18'" v-model="Bilet.UcusBilgileri.UcusNo1"
                                      label="Gidiş Uçuş No"></v-text-field>
                                    <v-text-field hide-details="" tabindex="19" v-model="Bilet.UcusBilgileri.UcusNo2"
                                      label="Gidiş Uçuş No"></v-text-field>
                                  </v-layout>
                                  <tarihim :etiket="'Dönüş Tarihi'" :tabindex="'20'"
                                    v-bind:value="Bilet.UcusBilgileri.UcusDonusTarihi"
                                    v-model="Bilet.UcusBilgileri.UcusDonusTarihi"></tarihim>
                                  <v-layout>
                                    <v-text-field hide-details="" tabindex=21 v-model="Bilet.UcusBilgileri.UcusDonusNo1"
                                      label="Dönüş Uçuş No"></v-text-field>
                                    <v-text-field hide-details="" tabindex="22"
                                      v-model="Bilet.UcusBilgileri.UcusDonusNo2" label="Dönüş Uçuş No"></v-text-field>
                                  </v-layout>
                                  <tarihim :etiket="'Rezervasyon Tarihi'" :tabindex="'23'"
                                    v-bind:value="Bilet.NotlarBilgileri.DateofRes"
                                    v-model="Bilet.NotlarBilgileri.DateofRes"></tarihim>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-card>
                    </v-flex>

                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2 style=" padding-bottom:10px; padding-right:10px;">
                  <v-card class="white--text">
                    <v-layout>
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <tarihim :etiket="'Satış Tarihi'" :tabindex="'24'" v-bind:defaultvalue="'ok'"
                                v-bind:value="Bilet.TarihBilgileri.SatisTarihi"
                                v-model="Bilet.TarihBilgileri.SatisTarihi"></tarihim>
                            </v-flex>

                            <tarihim :etiket="'Kesim Tarihi'" :tabindex="'25'" v-bind:defaultvalue="'ok'"
                              v-bind:value="Bilet.TarihBilgileri.KesimTarihi"
                              v-model="Bilet.TarihBilgileri.KesimTarihi"></tarihim>
                            <v-text-field hide-details="" tabindex="26" label="Kesen Kişi"
                              v-model="Bilet.GenelBilgileri.KesenKisi">
                            </v-text-field>
                            <v-text-field hide-details="" tabindex="27" v-model="Bilet.GenelBilgileri.PnrNo"
                              label="PNR"></v-text-field>
                            <v-text-field hide-details="" tabindex="28" v-model="Bilet.DigerBilgileri.PinKodu"
                              label="PIN Code"></v-text-field>
                            <v-select hide-details="" :items="biletyon" tabindex="29"
                              v-model="Bilet.GenelBilgileri.BiletYon" clearable item-text="text" item-value="value"
                              label="Yön"></v-select>
                            <v-select hide-details="" :items="classtip" tabindex="30"
                              v-model="Bilet.GenelBilgileri.ClassTip" clearable item-text="text" item-value="value"
                              label="Class Tip"></v-select>
                            <v-text-field hide-details="" type="number" tabindex="31"
                              v-model="Bilet.GenelBilgileri.YolcuAdet" label="Yolcu Adet"></v-text-field>
                            <v-select :items="fiyatturu" tabindex="32" hide-details="" clearable item-text="text"
                              item-value="value" v-model="Bilet.GenelBilgileri.FiyatTur" label="Fiyat Türü"></v-select>
                            <v-text-field hide-details="" tabindex="33" v-model="Bilet.GenelBilgileri.DepartmanKod"
                              label="Dep.Kod"></v-text-field>
                            <v-select :items="crskodu" hide-details="" tabindex="34" v-model="Bilet.GenelBilgileri.Crs"
                              clearable item-text="text" item-value="value" label="CRS"></v-select>
                            <v-text-field tabindex="35" v-model="Bilet.GenelBilgileri.ExBiletNo" hide-details=""
                              label="ECH Bilet No"></v-text-field>
                            <v-flex xs12 sm12 md12>
                              <masrafmerkezicomp :tabdeger="'36'" v-model="Bilet.GenelBilgileri.Masraf.Code">
                              </masrafmerkezicomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <referansmerkezicomp :tabdeger="'37'" v-model="Bilet.GenelBilgileri.Referans.Kod">
                              </referansmerkezicomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <bolumcomp :tabdeger="'38'" v-model="Bilet.TanimBilgileri.Bolum"></bolumcomp>
                            </v-flex>
                            <!-- <v-textarea label="Uyarı Notu" tabindex="22" v-model="Bilet.GenelBilgileri.MusteriKodu.Uyari"
                        hide-details=""></v-textarea> -->
                            <v-textarea label="Notlar" tabindex="39" v-model="Bilet.NotlarBilgileri.Aciklama2"
                              hide-details=""></v-textarea>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-layout>
                  </v-card>
                </v-flex>


                <v-flex xs12 sm6 md4 style=" padding-right:10px;">

                  <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                    <v-card class="white--text">
                      <v-layout>
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout row wrap>

                              <v-flex xs12 sm6 md6>
                                <v-layout row wrap>
                                  <parainput :etiket="'Bilet Tutarı'" :tabdeger="40"
                                    v-model="Bilet.TutarBilgileri.Tutar.Tutar" :autocomplete="'autocomplete'">
                                  </parainput>
                                  <v-flex v-if="dishatmi" xs12 sm12 md12>
                                    <parainput :etiket="'Tax'" :tabdeger="41"
                                      v-model="Bilet.TutarBilgileri.TaxTutar.TaxTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                  </v-flex>
                                  <v-flex v-if="ichatmi" xs12 sm12 md12>
                                    <parainput :etiket="'YFF'" :tabdeger="42"
                                      v-model="Bilet.TutarBilgileri.YFFTutar.YFFTutar" :autocomplete="'autocomplete'">
                                    </parainput>
                                  </v-flex>
                                  <v-flex v-if="ichatmi" xs12 sm12 md12>
                                    <parainput :etiket="'Alan Vergisi'" :tabdeger="43"
                                      v-model="Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar"
                                      :autocomplete="'autocomplete'"></parainput>
                                  </v-flex>
                                  <parainput :etiket="'Ceza'" :tabdeger="44"
                                    v-model="Bilet.TutarBilgileri.CezaTutar.CezaTutar" :autocomplete="'autocomplete'">
                                  </parainput>
                                  <parainput :etiket="'MCO PTA'" :tabdeger="45"
                                    v-model="Bilet.TutarBilgileri.PtaTutar.PtaTutar" :autocomplete="'autocomplete'">
                                  </parainput>
                                  <parainput :etiket="RezTutarEtiket" :tabdeger="46"
                                    v-model="Bilet.TutarBilgileri.ReserveTutar.ReserveTutar"
                                    :autocomplete="'autocomplete'"></parainput>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm6 md6>
                                <v-layout row wrap>
                                  <v-text-field label="Servis Kodu" @blur="serviscodeControl()" :placeholder="kodmesajı"
                                    append-icon="search" :append-icon-cb="servisgetir" tabindex="47"
                                    v-model="Bilet.TanimBilgileri.ServisKod" hide-details=""></v-text-field>
                                  <parainput :etiket="'Servis'" :tabdeger="48"
                                    v-model="Bilet.TutarBilgileri.ServisTutar.ServisTutar"
                                    :autocomplete="'autocomplete'"></parainput>
                                  <parainput :etiket="'İskonto'" :tabdeger="49"
                                    v-model="Bilet.TutarBilgileri.IskontoTutar.IskontoTutar"
                                    :autocomplete="'autocomplete'"></parainput>

                                  <v-layout justify-center="" column="" fill-height="">
                                    <v-flex xs12 sm12 md12 style="padding-right:2px;">
                                      <v-card color="#E53935" flat="" class="white--text">
                                        <v-divider light></v-divider>
                                        <v-card-actions class="pa-3">
                                          <span class="body font-weight-medium">
                                            Toplam Tutar : {{Bilet.TutarBilgileri.NetTutar.NetTutar}} ₺
                                          </span>
                                          <v-spacer></v-spacer>
                                        </v-card-actions>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-layout>
                    </v-card>
                  </v-flex>



                  <v-flex xs12 sm12 md12>
                    <v-card class="white--text">
                      <v-layout>
                        <v-card flat="">
                          <v-card-actions>
                            <v-layout row wrap>
                              <fatura :durum="faturanovarise" v-model="Bilet"></fatura>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-flex>


                <v-flex xs12 sm12 md2>
                  <v-flex xs12 sm12 md12>
                    <v-card class="white--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-select hide-details="" tabindex="62" v-model="Bilet.OdemeBilgileri.SatisSekli"
                              :items="satissekliitem" item-text="text" item-value="value" clearable
                              label=" Satış Şekli"></v-select>
                            <tarihim :etiket="'Ödeme Tarihi'" v-bind:defaultvalue="'ok'" :tabindex="'63'"
                              v-bind:value="Bilet.TarihBilgileri.OdemeTarihi"
                              v-model="Bilet.TarihBilgileri.OdemeTarihi"></tarihim>
                            <v-layout row wrap v-show="bankaposshow">
                              <v-flex xs12 sm12 md6>
                                <v-autocomplete :items="bankapositems" tabindex="64" hide-details=""
                                  v-model="Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu"
                                  @change="taksitgetir(Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu)"
                                  item-text="Aciklama" item-value="PosKodu" clearable label="Pos Kodu"></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm12 md6>
                                <v-select :items="taksitsayi" hide-details="" tabindex="65"
                                  v-model="Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod" item-text="TaksitAciklama"
                                  item-value="TaksitAdet" clearable label="Taksit"></v-select>
                              </v-flex>
                            </v-layout>
                            <v-flex v-if="bankaposshow" xs12 sm12 md12>

                              <parainput :etiket="'Puan Tutar'" :tabdeger="'66'"
                                v-model="Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar" :autocomplete="'autocomplete'">
                              </parainput>
                            </v-flex>
                            <v-layout row wrap v-show="servisposshow">
                              <v-flex xs12 sm12 md6>

                                <v-autocomplete :items="bankapositems" tabindex="67" hide-details=""
                                  @change="taksitgetirservis(Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu)"
                                  v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu"
                                  item-text="Aciklama" item-value="PosKodu" clearable label="Servis Pos Kodu">
                                </v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm12 md6>
                                <v-select :items="taksitsayiservis" hide-details="" tabindex="68"
                                  v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod"
                                  item-text="TaksitAciklama" item-value="TaksitAdet" clearable label="Taksit">
                                </v-select>
                              </v-flex>
                            </v-layout>
                            <v-flex v-if="servisposshow" xs12 sm12 md12>

                              <parainput :etiket="'Servis Pos Tutar'" :tabdeger="69"
                                v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar"
                                :autocomplete="'autocomplete'"></parainput>
                            </v-flex>


                            <v-text-field v-show="makbuznoshow" tabindex="70" v-model="Bilet.OdemeBilgileri.MakbuzNo"
                              hide-details="" label="Makbuz No"></v-text-field>
                            <v-text-field v-show="slipnoshow" label="Slip No" tabindex="71"
                              v-model="Bilet.OdemeBilgileri.Slipkod" hide-details=""></v-text-field>

                            <v-flex xs12 v-show="kredikartishow" sm12 md12>
                              <kredikartcomp :tabdeger="'72'" v-model="Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo">
                              </kredikartcomp>
                            </v-flex>

                            <v-layout>
                              <yuzdeinput :etiket="'H.Y. %'" :tabdeger="73" v-model="Bilet.OdemeBilgileri.HYOran"
                                :autocomplete="'autocomplete'"></yuzdeinput>
                              <parainput :etiket="'H.Y. Tutar'" :tabdeger="74"
                                v-model="Bilet.OdemeBilgileri.HavaYoluTutar" :autocomplete="'autocomplete'"></parainput>
                            </v-layout>
                            <v-flex xs12 sm12 md12>

                              <analizcomp :tabdeger="'75'" :etiket="'Analiz 1'"
                                v-model="Bilet.TanimBilgileri.AnalizKod.AnalizKod"></analizcomp>
                            </v-flex>
                            <v-layout>
                              <parainput :etiket="'Analiz Tutar'" :tabdeger="76"
                                v-model="Bilet.TanimBilgileri.AnalizTutar" :autocomplete="'autocomplete'"></parainput>
                              <parainput :etiket="'Döviz Tutar'" :tabdeger="77"
                                v-model="Bilet.TanimBilgileri.AnalizDoviz" :autocomplete="'autocomplete'"></parainput>
                            </v-layout>
                            <v-flex xs12 sm12 md12>
                              <analizcomp :tabdeger="'78'" :etiket="'Analiz 2'"
                                v-model="Bilet.TanimBilgileri.AnalizKod1.AnalizKod"></analizcomp>
                            </v-flex>
                            <v-layout>

                              <parainput :etiket="'Analiz2 Tutar'" :tabdeger="79"
                                v-model="Bilet.TanimBilgileri.AnalizTutar1" :autocomplete="'autocomplete'"></parainput>
                              <parainput :etiket="'Döviz Tutar'" :tabdeger="80"
                                v-model="Bilet.TanimBilgileri.AnalizDoviz1" :autocomplete="'autocomplete'"></parainput>
                            </v-layout>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>

            </v-tab-item>
            <v-tab href='#1' ripple>
              Uçuş Detay
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout v-if="tabviewucusdetay">
                <ucusdetay :ucus1="true" :ucus2="true" :ucus3="true" :ucus4="true" :ucus5="true"
                  v-model="this.UcusListesi"></ucusdetay>
              </v-layout>
            </v-tab-item>

            <v-tab href='#2' ripple>
              Tutar Detay
            </v-tab>
            <v-tab-item :id="'2'">
              <v-container fluid="" v-if="tabviewtutardetay">

                <tutarbilgileri :ichatmi="ichatmi" :dishatmi="dishatmi" v-model="Bilet"></tutarbilgileri>
              </v-container>
            </v-tab-item>

            <v-tab href='#3' ripple>
              Tahsİlat
            </v-tab>
            <v-tab-item :id="'3'">

              <v-container v-if="tabviewtahsilat" fluid="">
                <v-layout row="" wrap="">
                  <v-flex v-if="tahsilatbtn" xs12 sm4>
                    <v-btn color="info" @click="tahsilatekle()"> Yeni Kayıt Ekle
                      <v-icon right dark>add_circle_outline</v-icon>
                    </v-btn>
                  </v-flex>
                  <div class="flex md12">

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress"
                      :items="tahsilatitems" :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.Tarih }}</td>
                          <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                          <td class="text-xs-left">{{ props.item.Evrakno }}</td>
                          <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                          <td class="text-xs-left">{{ props.item.Tutar }}</td>
                          <td class="text-xs-left">{{ props.item.DovizCinsi }}</td>
                          <td class="text-xs-left">{{ props.item.DovizTutar }}</td>
                          <td class="text-xs-left">{{ props.item.PosKod }}</td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="tahsilatgetir(props.item)">
                              <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="tahsilatsil(props.item)">
                              <v-icon color="pink">delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </div>
                </v-layout>
              </v-container>
            </v-tab-item>

            <!-- <v-tab href='#4' ripple>
              Ödeme
            </v-tab>
            <v-tab-item :id="'4'">
              <v-container v-if="tabviewodeme" fluid="">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4>

                  </v-flex>
                  <div class="flex md12">

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="odemeitems"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.Tarih }}</td>
                          <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                          <td class="text-xs-left">{{ props.item.Evrakno }}</td>
                          <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                          <td class="text-xs-left">{{ props.item.Tutar }}</td>
                          <td class="text-xs-left">{{ props.item.DovizCinsi }}</td>
                          <td class="text-xs-left">{{ props.item.DovizTutar }}</td>
                          <td class="text-xs-left">{{ props.item.PosKod }}</td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="satirduzenle(props.item)">
                              <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="satirsil(props.item)">
                              <v-icon color="pink">delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </div>

                </v-layout>
              </v-container>




            </v-tab-item> -->


            <v-tab href='#5' ripple>
              Notlar
            </v-tab>
            <v-tab-item :id="'5'">
              <notlar v-if="tabviewnotlar" v-model="Bilet"></notlar>
            </v-tab-item>



            <v-tab href='#6' ripple>
              Özel Bilgiler
            </v-tab>
            <v-tab-item :id="'6'">
              <ozelbilgiler v-if="tabviewozel" v-model="Bilet"></ozelbilgiler>
            </v-tab-item>


            <v-tab v-show="iadetab" href='#7' ripple>
              Bİlet İade
            </v-tab>
            <v-tab-item :id="'7'">
              <v-container v-if="tabviewiade" fluid="">
                <v-layout row="" wrap="">

                  <div class="flex md12">
                    <v-card-title>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table :headers="headeriade" :loading="progress" :items="iadeitems" :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.TarihBilgileri.IadeTarihi }}</td>
                          <td class="text-xs-left">{{ props.item.GenelBilgileri.BiletNo}}</td>
                          <td class="text-xs-left">{{ props.item.GenelBilgileri.HavaYoluKodu }}</td>
                          <td class="text-xs-left">{{ props.item.TutarBilgileri.NetTutar.NetTutar}}</td>
                          <td class="text-xs-left">{{ props.item.GenelBilgileri.Formno}}</td>
                          <td class="text-xs-left">{{ props.item.GenelBilgileri.Sirano }}</td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="iadeduzenle(props.item)">
                              <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="iadeiptal(props.item)">
                              <v-icon color="pink">delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </div>
                </v-layout>
              </v-container>
            </v-tab-item>

            <!-- <v-tab href='#8' ripple>
              FATURA BİLGİLERİ
            </v-tab>
            <v-tab-item :id="'8'">
              <v-container fluid="">
                <v-layout row="" wrap="">

                  <div class="flex md3">
                    <v-btn color="info" :disabled="faturabtn" block @click="faturadialogac()">Fatura</v-btn>
                    <fatura :durum="faturanovarise" v-model="Bilet"></fatura>
                  </div>
                </v-layout>
              </v-container>
            </v-tab-item> -->
          </v-tabs>
        </v-layout>
      </v-card>
    </v-form>


    <v-dialog v-model="cokluyolcudialog" persistent max-width="300px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar color="info" size="120px" dark>
            <v-toolbar-title>Çoklu Yolcu Girişi</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-container fluid="">
            <v-layout row="" wrap="">
              <v-flex xs12 sm12 md12>
                <div v-for="item in objeler" :key="item.BiletNo">
                  <template>
                    <v-text-field hide-details="" :ref="item.vmodelname" :label="item.Label" :id="item.vmodelname">
                    </v-text-field>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="m === true">
            <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()">Sil</v-btn>
            <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">Güncelle</v-btn>
          </div>
          <v-btn color="blue darken-1" flat @click.native="cokluyolcudialog=false">Vazgeç</v-btn>
          <v-btn id="bkaydet" color="blue darken-1" flat @click="coklubiletkayit()">Devam Et</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog ref="yenidialog" v-model="yenidialog" persistent max-width="400px">
      <v-card color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Yeni Kayıt</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-layout wrap>
            <div class="flex md12">
              <yenibiletno v-model="Bilet"></yenibiletno>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a target="_self" v-bind:href="'#/bilet/index'">
            <v-btn color="blue darken-1" flat>Vazgeç</v-btn>
          </a>
          <v-btn id="bkaydet" color="blue darken-1" flat @click="biletislemsorgula()">Devam Et</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogkisamesaj" width="500">

      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Uyarı!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{this.kisamesaj}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogkisamesaj = false">
            Tamam
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="voiddialog" width="500">
      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Dikkat!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          Bu bileti void yapmak istediğinize emin misiniz?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="voiddialog = false">
            İptal
          </v-btn>
          <v-btn color="primary" flat @click="voidislem()">
            Kabul Et
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="tcdialog" persistent max-width="500px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">T.C. Kimlik Bilgileri Ekle</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>

              <div class="flex md12">
                <v-text-field hide-details="" label="T.C. Kimlik No"></v-text-field>

                <v-text-field hide-details="" label="Adı"></v-text-field>

                <v-text-field hide-details="" label="Soyadı"></v-text-field>
                <v-textarea label="Adres"></v-textarea>
                <v-layout>
                  <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Tel"></v-text-field>
                  <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Fax"></v-text-field>
                </v-layout>
                <v-text-field hide-details="" label="Mail"></v-text-field>


                <!-- <tarihcomp :etiket="'Doğum Tarihi'" v-bind:value="dateFormatted" v-model=""></tarihcomp> -->


                <v-text-field hide-details="" label="Anne Adı"></v-text-field>

                <v-text-field hide-details="" label="Baba Adı"></v-text-field>
                <v-text-field hide-details="" label="Anne Kızlık Soyadı"></v-text-field>
              </div>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="m === true">
            <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()">Sil</v-btn>
            <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">Güncelle</v-btn>
          </div>
          <v-btn color="blue darken-1" flat @click.native="tcdialog=false">VazgeÇ</v-btn>
          <div>
            <v-btn id="bkaydet" color="blue darken-1" flat @click="detaykaydet()">Kaydet</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="faturadialog" persistent max-width="1000px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Fatura Giriş</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <div class="flex md4">
                <div class="card card--tile ">
                  <div class="card__text grey darken-1 white--text">
                    <h3>Genel Bilgiler</h3>
                  </div>
                </div>

                <tarihim :etiket="'Fatura Tarihi'" v-bind:defaultvalue="'ok'" v-bind:value="Fatura.FaturaTarih"
                  v-model="Fatura.FaturaTarih"></tarihim>

                <v-layout>
                  <v-text-field hide-details="" v-model="Fatura.FaturaSeri" label="Fatura Seri"></v-text-field>

                  <v-text-field hide-details="" label="Fatura No" v-model="Fatura.FaturaNo"></v-text-field>
                </v-layout>
                <v-select :items="gibseri" tabindex="26" v-model="Fatura.GibSeri" hide-details="" clearable
                  item-text="Seri" item-value="Seri" label="GİB Seri"></v-select>
                <v-text-field hide-details="" label="Ünvanı1" v-model="Fatura.EFaturaBilgi.Unvani"></v-text-field>
                <v-text-field hide-details="" label="Ünvanı2" v-model="Fatura.EFaturaBilgi.Unvani2"></v-text-field>
                <v-text-field hide-details="" label="Adres1" v-model="Fatura.EFaturaBilgi.Adres1"></v-text-field>
                <v-text-field hide-details="" label="Adres2" v-model="Fatura.EFaturaBilgi.Adres2"></v-text-field>
                <v-text-field hide-details="" label="İl/İlçe" v-model="Fatura.EFaturaBilgi.IlceSehir"></v-text-field>
                <v-text-field hide-details="" label="Fatura Email" v-model="Fatura.EFaturaBilgi.Email"></v-text-field>
                <v-text-field hide-details="" label="Vergi Dairesi" v-model="Fatura.EFaturaBilgi.VergiDairesi">
                </v-text-field>
                <v-text-field hide-details="" label="Vergi No" v-model="Fatura.EFaturaBilgi.VergiNo"></v-text-field>
                <v-text-field hide-details="" label="T.C Kimlik No" v-model="Fatura.EFaturaBilgi.TcKimlikNo">
                </v-text-field>
                <div v-show="edoviztipishow">
                  <v-select hide-details="" :items="doviztipi"
                    @change="kurgetir1(BiletAyrintiliOdeme.Tarih,BiletAyrintiliOdeme.Doviz)"
                    v-model="Fatura.DovizBilgi.EDovizTipi" clearable item-text="DovizUnvan" item-value="DovizKod"
                    label="Döviz Tipi"></v-select>
                  <v-text-field v-model="Fatura.DovizBilgi.EKur" hide-details="" label="Kur"></v-text-field>
                </div>
                <div v-show="ddoviztipishow">
                  <v-select hide-details="" :items="doviztipi"
                    @change="kurgetir1(BiletAyrintiliOdeme.Tarih,BiletAyrintiliOdeme.Doviz)"
                    v-model="Fatura.DovizBilgi.DDovizTipi" clearable item-text="DovizUnvan" item-value="DovizKod"
                    label="Döviz Tipi"></v-select>
                  <v-text-field v-model="Fatura.DovizBilgi.DKur" hide-details="" label="Kur"></v-text-field>
                </div>
              </div>

              <div class="flex md4">
                <div class="card card--tile ">
                  <div class="card__text grey darken-1 white--text">
                    <h3>T.C No İle İşlem Görenler İçin</h3>
                  </div>
                </div>

                <v-text-field hide-details="" v-model="Fatura.EFaturaBilgi.Adi" label="Adı"></v-text-field>
                <v-text-field hide-details="" v-model="Fatura.EFaturaBilgi.Soyadi" label="Soyadı"></v-text-field>
                <v-text-field hide-details="" v-model="Fatura.EFaturaBilgi.TUnvani" label="Ünvanı"></v-text-field>
                <v-text-field hide-details="" v-model="Fatura.EFaturaBilgi.DigerAdi" label="Diğer Adı"></v-text-field>
                <v-text-field hide-details="" v-model="Fatura.EFaturaBilgi.OnAdiEki" label="Ön Adı Eki"></v-text-field>
                <div class="card card--tile ">
                  <div class="card__text grey darken-1 white--text">
                    <h3>Dizayn Seçenekler</h3>
                  </div>
                </div>
                <!-- <v-select :items="dizayntipi" v-model="Fatura.FaturaBilgi.FaturaTip" tabindex="26" hide-details=""
                  clearable item-text="text" @change="dizayngetir()" item-value="value" label="Dizayn Tipi"></v-select> -->
                <v-select :items="dizaynsec" @change="xsltsec(Fatura.FaturaBilgi.FaturaID)"
                  v-model="Fatura.FaturaBilgi.FaturaID" tabindex="26" hide-details="" clearable
                  item-text="FaturaAciklama" item-value="FaturaId" label="Dizayn Seç"></v-select>
                <v-select :items="xsltitems" tabindex="26" hide-details="" clearable item-text="XsltAciklama"
                  item-value="FaturaId" v-model="Fatura.FaturaBilgi.FaturaXSLTID" label="xslt Dosyası Seç"></v-select>
                <reportbrosablon ref="reportbrosablon" v-model="Fatura.FaturaBilgi.FaturaPdfID" dizayngrupadi="Fatura"
                  objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
              </div>
              <div class="flex md4">
                <div class="card card--tile ">
                  <div class="card__text grey darken-1 white--text">
                    <h3>Seçenekler</h3>
                  </div>
                </div>
                <v-checkbox label="Unvan ve Adres Bilgilerinde Değişiklik Yap." hide-details></v-checkbox>
                <v-checkbox @change="dizayngetir()" label="Dövizli Fatura Bas" v-model="Fatura.Opsiyonlar.DovizliFatura"
                  hide-details></v-checkbox>
                <v-checkbox label="Yolcu İsmi Basılmasın" v-model="Fatura.Opsiyonlar.YolcuGosterme" hide-details>
                </v-checkbox>
                <v-checkbox label="Ödeme Vadesi Basılmasın" hide-details></v-checkbox>
                <v-checkbox label="İskonto Basılmasın" hide-details></v-checkbox>
                <v-checkbox label="Faturada Döviz Toplam ve Kuru Bas." hide-details></v-checkbox>
                <v-checkbox label="Toplamdan KDV ve Matrah Hesapla" hide-details></v-checkbox>
                <v-checkbox label="Fatura Tekrar Basılıyor" hide-details></v-checkbox>
                <v-checkbox label="Fatura Detay Bas" v-model="Fatura.Opsiyonlar.FaturaDetayBas" hide-details>
                </v-checkbox>
              </div>
              <div class="flex md12">
                <v-text-field hide-details="" v-model="Fatura.FaturaBilgi.FaturaDipAciklama"
                  label="E-Fatura Dip Açıklama"></v-text-field>
              </div>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="m === true">
            <!-- <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()">Sil</v-btn>
            <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">Güncelle</v-btn> -->
          </div>
          <v-btn color="blue darken-1" flat @click.native="faturadialog=false">Vazgeç</v-btn>
          <div>
            <v-btn id="bkaydet" color="blue darken-1" flat @click="faturakaydet()">Kaydet</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="400">
      <v-card color="primary" dark>
        <v-card-text>
          Biletiniz Getiriliyor, Lütfen Bekleyiniz...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="servisdialog" max-width="500px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Servis Kodu Seçimi</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-layout row wrap>
            <div class="flex md12">
              <v-data-table :headers="headersservis" :loading="progress" :items="servisitems" hide-actions
                class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr @click="servissec(props.item)" item>
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                    <td class="text-xs-left">{{ props.item.Tutar }}</td>
                    <td class="text-xs-left">{{ props.item.DovizKod}}</td>
                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import dovizinput from '../customcomp/dovizinput'
  import tarihim from '../customcomp/tarihim'
  import cariaracomp from '../customcomp/cariaracomp'
  import ucusdetay from "@/components/app/bilet/partpage/ucusdetay.vue"
  import notlar from "@/components/app/bilet/partpage/notlar.vue"
  import ozelbilgiler from "@/components/app/bilet/partpage/ozelbilgiler.vue"
  import tutarbilgileri from "@/components/app/bilet/partpage/tutarbilgileri.vue"
  import fatura from "@/components/app/bilet/partpage/fatura.vue"
  import tahsilatdialog1 from "@/components/app/bilet/partpage/tahsilatdialog1.vue"
  import yenibiletno from "@/components/app/bilet/partpage/yenibiletdialog1.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
  import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import musteribilgipart from "@/components/app/bilet/partpage/musteribilgipart.vue"
  import logoo from '../../../assets/control'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"


  import Vue from 'vue';

  export default {
    data() {
      return {
        tabviewozel: false,
        tabviewgenel: true,
        tabviewiade: false,
        tabviewucusdetay: false,
        tabviewtutardetay: false,
        tabviewtahsilat: false,
        tabviewodeme: false,
        tabviewnotlar: false,
        bekletme: false,
        ReserveTutarLabel: null,
        objeler: [],
        biletcoklumu: false,
        yolcudisabled: false,
        toplubilet: [],
        cokluyolcudialog: false,
        eFaturaBilgi: null,
        headers: [{
            text: 'Ödeme Tarihi',
            value: 'Tarih'
          },
          {
            text: 'Evrak Tipi ',
            value: 'Evrak.Evrakkod',

          },
          {
            text: 'Evrak No',
            value: 'Evrakno'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama',
          },
          {
            text: 'Tutar',
            value: 'Tutar',
          },
          {
            text: 'Döviz Tipi',
            value: 'DovizCinsi',
          },
          {
            text: 'Döviz Tutar',
            value: 'DovizTutar',
          },
          {
            text: 'POS Kodu',
            value: 'PosKod',
          }

        ],

        headersservis: [{
            text: 'Kod',
            value: 'Kod'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama',

          },
          {
            text: 'Tutar',
            value: 'Tutar'
          },
          {
            text: 'Döviz',
            value: 'DovizKod',
          }
        ],
        headeriade: [{
            text: 'İade Tarihi',
            value: 'TarihBilgileri.IadeTarihi'
          },
          {
            text: 'Bilet No',
            value: 'GenelBilgileri.BiletNo',
          },
          {
            text: 'Hava Yolu Kodu',
            value: 'GenelBilgileri.HavaYoluKodu',

          },
          {
            text: 'Net Tutar',
            value: 'TutarBilgileri.NetTutar.NetTutar',
          },

          {
            text: 'Form No',
            value: 'GenelBilgileri.Formno'
          }, ,
          {
            text: 'Sıra No',
            value: 'GenelBilgileri.Sirano'
          },

        ],
        KrediLimiti: 0,
        RezTutarEtiket: null,
        denemedeger: "0001-01-01T00:00:00",
        Bilet: {
          GenelBilgileri: {
            ArkmanUsers: '',
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: null,
            UcusTipi: '',
            SiparisNo: 0,
            MusteriKodu: {
              Kod: '',
              Uyari: '',
              BilgiNotu: ''
            },
            KesenKisi: '',
            YolcuAdi: '',
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: '',
            },
            Classlar: {
              Class1: '',
              Class2: '',
              Class3: '',
              Class4: '',
              Class5: '',
            },
            FiyatTur: 'AD', //enum deger
            Referans: {
              Kod: ''
            },
            YolcuAdet: 1,
            Baglantili: false,
            PnrNo: '',
            RezervasyonVeren: '',
            RezervasyonAlan: '',
            Status: '', //enum
            Acente: '',
            AcenteKodu: '',
            ExBiletNo: '',
            ExBiletHY: '',
            ClassTip: 'E', //enum
            BiletYon: 'T', //enum
            DepartmanKod: '',
            Crs: 'Manuel', //enum
            Masraf: {
              Code: ''
            },
            Email: '',
            BiletTel: '',
          },
          TarihBilgileri: {
            KesimTarihi: null,
            SatisTarihi: null,
            IptalTarihi: null,
            IadeTarihi: null,
            OdemeTarihi: null,
          },
          UcusBilgileri: {
            UcusTarihi: null,
            UcusNo1: null,
            UcusNo2: null,
            UcusDonusTarihi: null,
            UcusDonusNo1: null,
            UcusDonusNo2: null,
            UcusListesi: []
          },
          FaturaBilgileri: {
            FaturaTarihi: null,
            FaturaSeri: null,
            FaturaNo: 0,
            EfaturaBilgileri: {
              FaturaNo: null,
              Guid: null,
              FaturaDurumu: null,
              SanalFaturaNo: null,
              GercekFaturaNo: null,
              BasimTarihi: null,
              Kullanici: null,
              GonderimSekli: 0,
              InternetSatis: 0,
              WebAdresi: null,
              OdemeSekli: 0,
              OdemeSekliAciklama: null,
              OdemeAraci: null,
              OdemeTarihi: null
            },
            AlisFaturaNo: null,
            ProformaSeri: null,
            ProformaNo: 0,
            ProformaTarihi: null,
            SatisFaturaID: null,
            MaliyetFaturaID: null,
            AlisFaturaTarihi: null,
            AlisFatNo: null,
            FaturaOtomatik: 0,
            IstinaKod: null,
            KdvKod: null,
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: ''
            },
            Kur: 0,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            PtaTutar: {
              PtaTutar: 0,
              PtaSatisDoviz: 0,
              PtaAlisDoviz: 0,
              PtaKdv: 0
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0,
            },
            CharterTutar: {
              CharterTutar: 0,
              CharterSatisDoviz: 0,
              CharterAlisDoviz: 0,
              CharterKdv: 0
            },
            YFFTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },

          OdemeBilgileri: {
            SatisSekli: 'K', //enum
            KomisyonTip: '', //enum
            HYOran: 0,
            GSAOran: 0,
            KrediliTutar: 0,
            KrediliDoviz: 0,
            PesinTutar: 0,
            PesinDoviz: 0,
            KrediKartTutar: 0,
            KrediKartDoviz: 0,
            KrediKartBilgi: {
              KrediKartNo: '',
              KrediKartAy: '',
              KrediKartYil: '',
              KrediKartCins: '',
              KrediKartTip: ''
            },
            AlisServisTutar: {
              AlisServisTutar: 0,
              AlisServisDoviz: 0,
              AlisServisKdv: 0
            },
            HavaYoluTutar: 0,
            HavaYoluKdv: 0,
            Csc: false,
            BankaBilgileri: {
              PosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                }
                //public List<BankaPosTaksit> Taksitler { get; set; }
              },
              ServisPosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                },
                Taksitler: []
              },

              ServisPosTutar: 0,
              TaksitKod: '',
              ServisTaksitKod: '',
              TaksitKodLabel: '',
              ServisTaksitKodLabel: '',
              PuanTutar: 0
            },
            Slipkod: '',
            MakbuzNo: '',
          },
          DigerBilgileri: {
            SaveTime: null,
            Entegre: false,
            BiletTanim: '',
            eservedTutar1: 0,
            ExIcDis: '',
            EntegreTablo: '',
            GrossTutar: 0,
            ExIcDis: '',
            CharterPtaKodu: '',
            pArkmanEntegre: '',
            PinKodu: '',
            RezervasyonID: '',
            SiparisID: '',
            CKLogID: 0,
            ExIcDis: '',
            ParkurTip: '',
            DServisKod1: '',
            DServisKod2: '',
            KKEnt: '',
            SatisSapEntegre: '',
            MaliyetSapEntegre: '',
            KisiID: 0,
            ExIcDis: '',
            // EntegrasyonID: guid değişkeni
            UserID: 0,
            ExIcDis: ''
          },
          TanimBilgileri: {
            ServisKod: '',
            AnalizKod: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar: 0,
            AnalizDoviz: 0,
            AnalizKod1: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar1: 0,
            AnalizDoviz1: 0,
            TcKimlikNolar: {
              TcNo1: '',
              TcNo2: '',
              TcNo3: '',
              TcNo4: '',
              TcNo5: ''
            },
            Aciklamalar: {
              Aciklama1: '',
              Aciklama2: '',
              Aciklama3: '',
              Aciklama4: '',
              Aciklama5: '',
              Aciklama6: '',
              Aciklama7: '',
            },
            MilKodu: {
              MilKoduOde: '',
              MilKoduYolcu: '',
              MilAdet: 0,
              MilTutar: 0
            },
            MusteriPersonel: {
              PersonelUcan: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              },
              PersonelSponsor: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              }
            },
            YolcuCrm: {
              CrmYolcu: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              },
              CrmRezervasyon: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              }
            },
            ProfilID: 0,
            SablonID: 0,
            Bolum: '',
            EventID: '',
            ExAciklamalar: {
              ID: 0,
              SirketKodu: 0,
              Biletno: '',
              HavayoluKod: '',
              EmployeeId: '',
              DepartmentId: '',
              CostCenter: '',
              ClientId: '',
              DkNumber: '',
              WwId: '',
              BusinessUnit: '',
              CompanyCode: '',
              SiteCode: '',
              PurposeOt: '',
              PcNumber: '',
              NoHotelBc: '',
              TripApprover: ''
            }
          },
          AyrintiOdemeBilgileri: [],
          NotlarBilgileri: {
            SirketKodu: 0,
            BiletNo: '',
            FormNo: '',
            Aciklama1: '',
            Aciklama2: '',
            Segment1: '',
            Segment2: '',
            Segment3: '',
            Segment4: '',
            Segment5: '',
            RefFare: 0,
            LowFare: 0,
            RealCode: '',
            DateofRes: null,
            MarketCode: '',
            TicketSuffix: '',
            VendorNumber: '',
            ReasonCode: '',
            CRSGDS: '',
            SubPruductCode: '',
            TicketTypeInd: false,
            TourCode: '',
            AlternatifTutar1: 0,
            AlternatifTutar2: 0,
            AlternatifTutar3: 0,
            Anlasmali: false,
            Esnek: false,
            KarbonSalinimi: 0,
            Mil1: 0,
            Mil2: 0,
            Mil3: 0,
            Mil4: 0
          },

          TaksitBilgileri: {
            ID: 0,
            SirketKodu: 0,
            BiletNo: '',
            HavaYoluKodu: '',
            MakbuzNo: '',
            CCNo1: '',
            Tip1: '',
            Ay1: 0,
            Yil1: 0,
            Tutar1: 0,
            Iade1: 0,
            Taksit1: 0,
            TVade1: null,
            PosKodu1: '',
            CCNo2: '',
            Tip2: '',
            Ay2: 0,
            Yil2: 0,
            Tutar2: 0,
            Iade2: 0,
            Taksit2: 0,
            TVade2: null,
            PosKodu2: '',
            CCNo3: '',
            Tip3: '',
            Ay3: 0,
            Yil3: 0,
            Tutar3: 0,
            Iade3: 0,
            Taksit3: 0,
            TVade3: null,
            PosKodu3: '',
            CCNo4: '',
            Tip4: '',
            Ay4: 0,
            Yil4: 0,
            Tutar4: 0,
            Iade4: 0,
            Taksit4: 0,
            TVade4: null,
            PosKodu4: '',
            PesinSatisTutari: 0,
            PesinIadeTutari: 0,
            SlipKod1: '',
            SlipKod2: '',
            SlipKod3: '',
            SlipKod4: '',
            OdemeFaturaId: '',
            OdemeSapEntegre: '',
          }
        },

        faturanodisabled: false,
        UcusList: [],

        UcusListesi: {
          Ucus1: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus2: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus3: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus4: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          },
          Ucus5: {
            Aktarma: false,
            BiletNo: '',
            FareBases: 0,
            Formno: '',
            ID: '',
            Parkur: '',
            ParkurNo: '',
            SirketKodu: '',
            UcusClass: '',
            UcusHY: '',
            UcusNo: '',
            UcusSaat: '',
            UcusTarihi: null,
            VarisSaat: '',
            VarisTarihi: null
          }
        },

        servisclass: {
          SirketKodu: '',
          Cari: {
            Kod: null
          },
          Parkurlar: {
            Parkur1: '',
            Parkur2: '',
            Parkur3: '',
            Parkur4: '',
            Parkur5: '',
          },
          Hat: ''
        },

        BiletAyrintiliOdeme: {
          SirketKodu: null,
          ID: 0,
          Tarih: getDateNow(),
          EvrakCinsi: null,
          Doviz: null,
          Kur: 0,
          Tutar: 0,
          DovizTutar: 0,
          PosKod: null,
          OdemeKod: 0,
          Nereden: null,
          EvrakNo: null,
          KrediKartNo: null,
          Aciklama: null,
          TaksitKod: null,
          TaksitKodLabel: null,
          PuanTutar: 0,
          BankaKod: null,
          KarsiCari: ' ',
          TanimID: 0,
          BiletNo: null,
          FormNo: null,
          CariKod: null,
          Referans: null,
          Masraf: null,
          Faturano: null,
          FaturaTarih: null,
          FaturaSeri: null
        },

        BiletIade: {
          GenelBilgileri: {
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: '',
            Sirano: '',
            UcusTip: '',
            Cari: {
              Kod: ''
            },
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: ''
            },
            IadeUcusTip: '', //enum
            KesenKisi: '',
            Masraf: {
              Code: ''
            },
            Referans: {
              Kod: ''
            },
            Crs: '', // enum
            Notlar: '',
          },
          TarihBilgileri: {
            IadeTarihi: null,
            VadeTarihi: null,
            IadeFaturaTarihi: null
          },
          FaturaBilgileri: {
            IadeFaturaNo: null,
            DekontNo: null,
            ServisFaturaNo: null,
            IadeFaturaGelenBelgeNo: null
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: null
            },
            Kur: 0,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            YffTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0,
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            IadeServisTutar: {
              IadeServisTutar: 0,
              IadeServisDoviz: 0,
              IadeServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },
          OdemeBilgileri: {
            Odeme: false,
            KrediliTutar: 0,
            KrediliDvzTutar: 0,
            PesinTutar: 0,
            PesinDvzTutar: 0,
            KrediKartTutar: 0,
            KrediKartDvzTutar: 0,
            HY: 0,
            GSA: 0,
            HavayoluTutar: 0,
            Analiz: {
              AnalizKod: ''
            },
            AnalizTutar: 0,
            AnalizDvzTutar: 0,
            Analiz1: {
              AnalizKod: ''
            },
            AnalizTutar1: 0,
            AnalizDvzTutar1: 0,
          },
          DigerBilgileri: {
            IadeTanim: null,
            Entegre: null,
            ExIcDis: null,
            CkLogId: null,
            ParkurTip: null,
            KKEnt: null,
            IadeDekontID: null,
            IadeMaliyetDekontID: null,
            IadeSapEntegre: null,
            IadeMaliyetSapEntegre: null,
            // public Guid EntegrasyonID { get; set; }
            ServisFark: false,
            DekontPusula: '', //enum
            AlisEntegre: null,
          }
          //  public LoginInfo LoginBilgileri { get; set; }
        },

        //----------------------------------------------------------------------------------------

        Fatura: {
          SirketKodu: null,
          FaturaTarih: null,
          FaturaSeri: null,
          FaturaNo: null,
          GibSeri: null,
          BiletBilgi: {
            SirketKodu: null,
            BiletNo: null,
            FormNo: null,
            OdemeTarihi: null,
            CariKod: [],
            NetTutar: 0

          },
          EFaturaBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null,
          },
          FaturaBilgi: {
            FaturaTip: 'O',
            FaturaID: 2,
            FaturaXSLTID: null,
            FaturaPdfID: null,
            FaturaDipAciklama: null
          },
          Opsiyonlar: {
            YolcuGosterme: false,
            DovizliFatura: false,
            FaturaDetayBas: false
          },
          EArsivBilgi: {
            GonderimSekli: null,
            InternetSatis: null,
            WebAdresi: null,
            OdemeSekli: null,
            OdemeSekliAciklama: null,
            OdemeAraci: null,
            OdemeTarihi: null,
          },
          DovizBilgi: {
            EDovizTipi: null,
            EKur: 0,
            DDovizTipi: null,
            DKur: 0
          }
        },
        yenidialog: false,
        tabcontroltahsilat: 0,
        tabcontrolodeme: 0,
        tabcontroliade: 0,
        tabcontroltutar: 0,
        search3: '',
        searchcari: '',
        itemsairlinelist: [],
        odemeitems: [],
        tahsilatitems: [],
        analizitems: [],
        itemsparkur: [],
        bankapositems: [],
        classitems: [],
        Referans: [],
        satiritems: [],
        taksitsayi: [],
        odemesekilleri: [],
        dizayntipi: [{
            text: 'Default',
            value: 'O'
          },
          {
            text: 'Özel',
            value: 'O'
          },
        ],
        dizaynsec: [],
        dizaynxslt: [{
          text: 'tek değer',
          value: '0'
        }, ],
        crskodu: [{
          text: 'Manuel',
          value: 'Manuel'
        }, {
          text: 'Amadeus Dış Hat',
          value: 'AmadeusDisHat'
        }, {
          text: 'TK İç Hat',
          value: 'TkIcHat'
        }, {
          text: 'Atlas',
          value: 'Atlas'
        }, {
          text: 'Pegasus',
          value: 'Pegasus'
        }, {
          text: 'Onur',
          value: 'Onur'
        }, {
          text: 'SunExpress',
          value: 'SunExpress'
        }, {
          text: 'Galileo İç Hat',
          value: 'GalileoIcHat'
        }, {
          text: 'Galileo Dış Hat',
          value: 'GalileoDisHat'
        }, {
          text: 'WorldSpan',
          value: 'Worldspan'
        }, {
          text: 'BoraJet',
          value: 'BoraJet'
        }, {
          text: 'IATI',
          value: 'IATI'
        }, {
          text: 'Sabre',
          value: 'Sabre'
        }, {
          text: 'Bilet Bank',
          value: 'BiletBank'
        }, {
          text: 'Kolay Bilet',
          value: 'KolayBilet'
        }],
        odemesekli1: [{
            text: 'Kredi-Banka Kartı',
            value: '0'
          },
          {
            text: 'EFT-Havale',
            value: '1'
          },
          {
            text: 'Kapıda Ödeme',
            value: '2'
          },
          {
            text: 'Ödeme Aracısı',
            value: '3'
          },
          {
            text: 'Diğer',
            value: '4'
          }
        ],
        komisyontip: [{
          text: 'K-Komisyonlu',
          value: 'K'
        }, {
          text: 'P-Komisyonsuz',
          value: 'N'
        }],
        satissekliitem: [{
          text: 'K-Kredili',
          value: 'K'
        }, {
          text: 'P-Peşin',
          value: 'P'
        }, {
          text: 'R-Kartlı',
          value: 'R'
        }, {
          text: 'C-Kartlı',
          value: 'C'
        }, {
          text: 'F-Kredi Kartlı',
          value: 'F'
        }],
        fiyatturu: [{
            text: 'AD-Yetişkin',
            value: 'AD'
          },
          {
            text: 'CHD-Çocuk',
            value: 'CHD'
          },
          {
            text: 'INF-Bebek',
            value: 'INF'
          },
          {
            text: 'TUS-Diplomatik',
            value: 'TUS'
          },
          {
            text: 'EX',
            value: 'EX'
          },
          {
            text: 'STD-Öğrenci',
            value: 'STD'
          },
          {
            text: 'SRC-Yaşlı',
            value: 'SRC'
          },
          {
            text: 'MIL-Asker',
            value: 'MIL'
          },
          {
            text: 'YTH-Genç',
            value: 'YTH'
          }
        ],
        biletyon: [{
            text: 'T-Tek Yön',
            value: 'T'
          },
          {
            text: 'C-Çift Yön',
            value: 'C'
          },
          {
            text: 'R-Gidiş Geliş',
            value: 'R'
          }
        ],
        classtip: [{
            text: 'B-Business',
            value: 'B'
          },
          {
            text: 'C-Premium Economy',
            value: 'C'
          },
          {
            text: 'E-Economy',
            value: 'E'
          },
          {
            text: 'F-First Class',
            value: 'F'
          },
          {
            text: 'P-Promosyon',
            value: 'P'
          },
          {
            text: 'X-Infant',
            value: 'X'
          }
        ],
        kredikartiitems: [],
        xsltitems: [],
        itemsevraktipi: [],
        defaultvalue: null,
        tahsilatbtn: false,
        iadetab: false,
        postaksitsayi: '',
        servistaksitsayi: '',
        acentabiletimi: false,
        baslik_mesaji: '',
        ucus1: false,
        ucus2: false,
        ucus3: false,
        ucus4: false,
        ucus5: false,
        loadingdialog: false,
        servisdialog: false,
        tahsilatdialog: false,
        voiddialog: false,
        dialog_baslik: '',
        tcdialog: false,
        m: false,
        k: false,
        progress: false,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],
        statecaritahsilat: [],
        servisitems: [],
        search: '',
        search1: '',
        earsivseridurum: null,
        loading: false,
        Uyelik: {
          MusteriInfo: {
            MusteriID: null,
            MusteriKod: null,
          },
          ProgramTip: [],
          UyelikTip: 0,
          UyelikBitis: null,
          KalanKontor: 0,
          UyelikStatus: false
        },


        musteritipi: [{
            text: 'Bireysel',
            value: 'B'
          },
          {
            text: 'Kurumsal',
            value: 'K'
          }
        ],
        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],
        islembilgileri: [{
            text: 'Kağıt Fatura',
            value: 'false'
          },
          {
            text: 'Elektronik Fatura',
            value: 'true'
          }
        ],
        cmkodu: [
          'C', 'M'
        ],
        doviztipi: [],
        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],
        evethayir: [{
            text: 'Evet',
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],
        ucustipi: [{
            text: 'İç Hat',
            value: 'I'
          },
          {
            text: 'Dış Hat',
            value: 'D'
          },
          {
            text: 'BSP',
            value: 'B'
          }
        ],
        faturatipi: [{
            text: 'Satış Faturası',
            value: 0
          },
          {
            text: 'İade Faturası',
            value: 1
          }
        ],
        gonderimsekli: [{
            text: 'Kağıt',
            value: 0
          },
          {
            text: 'Elektronik',
            value: 1
          }
        ],
        odemesekli: [{
            text: 'Normal Satış',
            value: 0
          },
          {
            text: 'İnternet Satış',
            value: 1
          }
        ],
        kodmesajı: null,
        edoviztipishow: false,
        ddoviztipishow: false,
        anasatisislem: '',
        faturadialog: false,
        tahsilatguncellebuton: false,
        kisamesaj: '',
        dialogkisamesaj: false,
        servisposshow: true,
        bankaposshow: true,
        kredikartishow: true,
        slipnoshow: true,
        makbuznoshow: true,
        biletnodisabled: false,
        guncellebuton: false,
        guncellebtngorunum: false,
        voiddurum: false,
        voidiptalbtn: false,
        voidbtn: false,
        iadebtn: false,
        iadeitems: [],
        taksitsayiservis: [],
        taksitsayitahsilat: [],
        itemsbanka: [],
        bolumler: [],
        uyeliktipi: null,
        kalankontor: 0,
        dictionary: {
          custom: {
            faturaseri: {
              required: () => 'zorunlu alan'
            },
            faturano: {
              required: () => 'zorunlu alan'
            },
            faturatarih: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            faturatagib: {
              required: () => 'Lütfen bir seçim yapınız'
            },
          }
        },
        faturabtn: true,
        ichatmi: false,
        dishatmi: false,
        gibseri: [],
        faturanovarise: false,
        vadegunsayisi: 0,
        artieksi: null,
        StartDate: null,
        EndDate: null,
        kaydetbuton: false,
        datesatistarihi: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
      }
    },

    mounted() {
      this.$validator.localize('en', this.dictionary)

      if (this.$route.query.isl == 'get') {

        var biletparams = {
          SirketKodu: credentials.SirketKodu,
          BiletNo: this.$route.query.biletno,
          HavaYoluKodu: this.$route.query.hyolukod,
          UcusTipi: this.$route.query.ucustipi
        }




        this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {









          this.Bilet.GenelBilgileri.Referans.Kod = String(response.body.GenelBilgileri.Referans.Kod)

          if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
            this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
          }

          this.postaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.TaksitKod

          this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

          if (response.body.FaturaBilgileri.FaturaNo != null && response.body.FaturaBilgileri.FaturaNo != '') {
            this.Fatura.FaturaTarih = response.body.FaturaBilgileri.FaturaTarihi
            this.Fatura.FaturaSeri = response.body.FaturaBilgileri.FaturaSeri
            this.Fatura.FaturaNo = response.body.FaturaBilgileri.FaturaNo
            this.faturanovarise = true
          } else {}

          if (response.body.FaturaBilgileri.FaturaSeri == 'H') {
            this.faturalansinmi = false
          }




          this.Bilet = response.body




          // fatura no varsa güncellenemez void yapılamaz
          var fatno = response.body.FaturaBilgileri.FaturaNo

          if (fatno != null && fatno != 0) {



          } else {


          }

          if (response.body.GenelBilgileri.Acente == 'A') {
            this.baslik_mesaji = '*** Bu bilet ' + this.Bilet.GenelBilgileri.AcenteKodu +
              ' acentasından alınmıştır'
          } else {
            this.baslik_mesaji = ""

          }




        }, (response) => {
          if (response.status === 0) {
            console.log('')


            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            console.log('')



            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })





      }
    },
    methods: {
      biletyazdir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaSeri: this.Bilet.FaturaBilgileri.FaturaSeri,
          FaturaNo: this.Bilet.FaturaBilgileri.FaturaNo,
          FaturaGuid: this.Bilet.FaturaBilgileri.EfaturaBilgileri.Guid
        }

        this.$http.post(auth.API_URL + 'api/Invoice/EInvoiceList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.Fatura.FaturaBilgi.FaturaPdfID = response.body[0].FaturaPdfID
          var prm = {
            id: response.body[0].EfaturaID,
            guid: response.body[0].GuiID
          };

          this.$refs.reportbrosablon.Print(prm).then(
            confirm => {
              // this.status.loading = false;
            },
            confirm => {
              //  this.status.loading = false;
            }
          );


        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-EInvoiceList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-EInvoiceList'
            this.snackbar = true
          }
        })


      },
      xsltsec(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {
            this.Fatura.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId
            this.Fatura.FaturaBilgi.FaturaPdfID = element.FaturaPdfID
          }
        });
      },
      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      iadeduzenle(k) {
        var url = '#/bilet/biletiade/id?' + 'isl=iadeget&hyolukod=' + k.GenelBilgileri.HavaYoluKodu + '&biletno=' + k
          .GenelBilgileri
          .BiletNo + '&formno=' + k.GenelBilgileri.Formno + '&sirano=' + k.GenelBilgileri.Sirano + '&ucustipi=' + this
          .Bilet
          .GenelBilgileri.UcusTipi
        window.open(url, '_self')
      },
      dizayngetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var hattipi = null

        if (this.Bilet.GenelBilgileri.UcusTipi == 'I') {
          hattipi = false
        } else {
          hattipi = true
        }

        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: this.Fatura.FaturaBilgi.FaturaTip,
          DovizliFatura: this.Fatura.FaturaBilgi.DovizliFatura,
          HatTipi: hattipi,
          TumFiltre: true
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })

      },
      faturadialogac() {

        if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var hattipi = null

          if (this.Bilet.GenelBilgileri.UcusTipi == 'I') {
            hattipi = false
          } else {
            hattipi = true
          }

          var params = {
            SirketKodu: credentials.SirketKodu,
            FaturaTip: 'O',
            DovizliFatura: false,
            TumFiltre: true,
            HatTipi: hattipi
          }

          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.dizaynsec = response.body
          }, (response) => {
            if (response.status === 0) {
              this.progress = false
              this.text1 = 'Service Unavailable-InvoiceMainTableList'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-InvoiceMainTableList'
              this.snackbar = true
            }
          })

          var paramsxslt = {
            CompanyCode: credentials.SirketKodu,

          }


          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.xsltitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.progress = false
              this.text1 = 'Service Unavailable-InvoiceXsltTableList'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-InvoiceXsltTableList'
              this.snackbar = true
            }
          })


          //0 ise Earşiv / 1 ise gib seri

          if (this.earsivseridurum == 1) {

            var params1 = {
              CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })
          }



          if (this.earsivseridurum == 0) {

            var params1 = {
              CompanyCode: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })
          }

          var faturabilgi = null

          if (this.eFaturaBilgi == 0) {
            faturabilgi = false
          } else {
            faturabilgi = true
          }

          var params1 = {
            SirketKodu: credentials.SirketKodu,
            EFaturaBilgi: faturabilgi,
            EArsivBilgi: false,
            ParamKontrol: true,
            InternetSatis: this.Bilet.FaturaBilgileri.EfaturaBilgileri.InternetSatis
          }

          this.$http.post(auth.API_URL + 'api/TicketHelpers/GetLastBillNumber', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.Fatura.FaturaSeri = response.body.FaturaSeri
            this.Fatura.FaturaNo = response.body.FaturaNo

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })

          this.faturadialog = true
        } else {
          this.text1 = 'Fatura işlemlerinden önce lütfen Cari kodunuzu seçiniz.'
          this.snackbar = true
        }





      },
      yeniiadeekle() {
        var url = '#/bilet/biletiade/id?' + 'isl=yeniiade&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
          '&biletno=' + this.Bilet.GenelBilgileri.BiletNo + '&formno=' + this.Bilet.GenelBilgileri.Formno + '&sirano=' +
          this.Bilet.GenelBilgileri.Sirano + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi
        window.open(url, '_self')
      },
      kurgetir(tarih, kod) {
        var params1 = {
          Tarih: tarih,
          DovizKod: kod
        }

        if (tarih != null && tarih != '') {
          this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.BiletAyrintiliOdeme.Kur = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }

      },
      kurgetirfatura(tarih, kod) {
        var params1 = {
          Tarih: tarih,
          DovizKod: kod
        }

        if (tarih != null && tarih != '') {
          this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.BiletAyrintiliOdeme.Kur = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }

      },

      sayfakapat() {
        var url1 = '#/bilet/index'
        window.open(url1, '_self')
      },

      voidyap() {
        this.voiddialog = true
      },
      tahsilatekle() {

        //alanları temizleyelim

        this.BiletAyrintiliOdeme.CariKod = null
        this.BiletAyrintiliOdeme.Referans = null
        this.BiletAyrintiliOdeme.Masraf = null
        this.BiletAyrintiliOdeme.EvrakCinsi = null
        this.BiletAyrintiliOdeme.Doviz = null
        this.BiletAyrintiliOdeme.Kur = 0
        this.BiletAyrintiliOdeme.Tarih = getDateNow()
        this.BiletAyrintiliOdeme.Tutar = 0
        this.BiletAyrintiliOdeme.DovizTutar = 0
        this.BiletAyrintiliOdeme.PosKod = null
        this.BiletAyrintiliOdeme.EvrakNo = null
        this.BiletAyrintiliOdeme.KrediKartNo = null
        this.BiletAyrintiliOdeme.Aciklama = null
        this.BiletAyrintiliOdeme.TaksitKod = null
        this.BiletAyrintiliOdeme.TaksitKodLabel = null
        this.BiletAyrintiliOdeme.PuanTutar = 0
        this.BiletAyrintiliOdeme.BankaKod = null
        this.BiletAyrintiliOdeme.KarsiCari = ''

        //ana sayfadan kaydet için alınacak alanlar

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
        this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
        this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
        this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
        this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
        this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
        this.BiletAyrintiliOdeme.Faturano = this.Bilet.FaturaBilgileri.FaturaNo
        this.BiletAyrintiliOdeme.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarih
        this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri

        this.$refs.tahsilatdialog1.open("tahsilat").then(sonuc => {
          if (sonuc == true) {

            //kayıt başarılı ise listeyi güncelleyelim

            var tahsilatparams = {
              SirketKodu: credentials.SirketKodu,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FormNo: this.Bilet.GenelBilgileri.Formno,
              BA: 1
            }
            this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.tahsilatitems = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })
          }
        });

      },
      servissec(v) {

        var params = {
          ServisKodBilgi: v,
          KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
          TutarBilgi: {
            ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
            BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
            VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet.TutarBilgileri.AlanVergiTutar
              .AlanVergitutar +
              this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
          }
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar
          this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-GetServiceCodePrice'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-GetServiceCodePrice'
            this.snackbar = true
          }
        })
        this.Bilet.TanimBilgileri.ServisKod = v.Kod
        this.servisdialog = false


      },
      getDateNow: getDateNow,
      carigetir: carigetir,
      carigetir2: carigetir2,
      tahsilatkaydet: tahsilatkaydet,
      caribilgigetir: caribilgigetir,
      taksitgetir: taksitgetir,
      taksitgetirservis: taksitgetirservis,
      taksitgetirtahsilat: taksitgetirtahsilat,
      biletislemsorgula: biletislemsorgula,
      biletkaydet: biletkaydet,
      servisgetir: servisgetir,
      voidislem: voidislem,
      voidiptal: voidiptal,
      tarihformatla: tarihformatla,
      tahsilatgetir: tahsilatgetir,
      tahsilatsil: tahsilatsil,
      tahsilatguncelle: tahsilatguncelle,
      iadeiptal: iadeiptal,
      faturakaydet: faturakaydet,
      coklubiletkayit: coklubiletkayit,
      serviscodeControl: serviscodeControl,
      tutarTopla: tutarTopla,
      tutarToplaSatisDoviz: tutarToplaSatisDoviz,
      tutarToplaAlisDoviz: tutarToplaAlisDoviz,
    },
    beforeMount: beforeMount,

    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'cariaracomp': cariaracomp,
      'ucusdetay': ucusdetay,
      'notlar': notlar,
      'ozelbilgiler': ozelbilgiler,
      'tutarbilgileri': tutarbilgileri,
      'fatura': fatura,
      'tahsilatdialog1': tahsilatdialog1,
      'yenibiletno': yenibiletno,
      'masrafmerkezicomp': masrafmerkezicomp,
      'referansmerkezicomp': referansmerkezicomp,
      'bolumcomp': bolumcomp,
      reportbrosablon,
      tarihim,
      parkurcomp,
      kredikartcomp,
      analizcomp,
      musteribilgipart
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      },
      active(val1) {
        //tablar aktif olunca değerleri çekelim

        if (val1 == 0) {
          this.tabviewozel = false;
          this.tabviewgenel = true;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;
        } else if (val1 == 1) {
          this.tabviewozel = false;
          this.tabviewiade = false;
          this.tabviewucusdetay = true;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;
        } else if (val1 == 2) {
          this.tabviewozel = false;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = true;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;
        } else if (val1 == 3) {
          this.tabviewozel = false;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = true;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;
        } else if (val1 == 4) {
          this.tabviewozel = false;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = true;
          this.tabviewnotlar = false;
        } else if (val1 == 5) {
          this.tabviewozel = false;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = true;
        } else if (val1 == 6) {
          this.tabviewozel = true;
          this.tabviewiade = false;
          this.tabviewucusdetay = false;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;
        } else if (val1 == 7) {
          this.tabviewozel = false;
          this.tabviewiade = true;
          this.tabviewucusdetay = true;
          this.tabviewtutardetay = false;
          this.tabviewtahsilat = false;
          this.tabviewodeme = false;
          this.tabviewnotlar = false;

        }

        if (val1 == 3 && this.tabcontroltahsilat != 1) {
          this.tabcontroltahsilat = 1
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var tahsilatparams = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            BA: 1
          }

          this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.tahsilatitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
        if (val1 == 4 && this.tabcontrolodeme != 1) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.tabcontrolodeme = 1

          var odemeparams = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            BA: 0
          }

          this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', odemeparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.odemeitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })

        }

        if (val1 == 7 && this.tabcontroliade != 1) {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.tabcontroliade = 1
          var iadeparams = {

            SirketKodu: credentials.SirketKodu,
            HavaYoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            Sirano: 0,
            BaslangicTarihi: null,
            BitisTarihi: null
          }

          this.$http.post(auth.API_URL + 'api/Ticket/RefundList', iadeparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.iadeitems = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Bilet İade List'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Bilet İade List'
              this.snackbar = true
            }
          })

        }

        if (val1 == 2 && this.tabcontroltutar != 1) {

          this.tabcontroltutar = 1


        }

      },
      loadingdialog(val) {
        if (!val) return
        setTimeout(() => (this.loadingdialog = false), 4000)
      },

      'Fatura.FaturaSeri': function (valueseri) {
        this.Fatura.FaturaSeri = valueseri.toUpperCase()
      },
      'Bilet.GenelBilgileri.MusteriKodu.Kod': function (valuecari) {
        this.caribilgigetir();
      },


      'Bilet.TutarBilgileri.Tutar.Tutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.TaxTutar.TaxTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.YFFTutar.YFFTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.CezaTutar.CezaTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.ServisTutar.ServisTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.ReserveTutar.ReserveTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.IskontoTutar.IskontoTutar': function (value1) {
        this.tutarTopla();
      },

      'Bilet.TutarBilgileri.CharterTutar.CharterTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.KaTutar.KaTutar': function (value1) {
        this.tutarTopla();
      },
      'Bilet.TutarBilgileri.Tutar.TutarSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.YFFTutar.YFFDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.ServisTutar.ServisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.KaTutar.KaDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },
      'Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz': function (value1) {
        this.tutarToplaSatisDoviz();
      },

      'Bilet.TutarBilgileri.Tutar.TutarAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar': function (value1) {
        this.tutarToplaAlisDoviz();
      },
      'Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz': function (value1) {
        this.tutarToplaAlisDoviz();
      },

      'Bilet.TarihBilgileri.SatisTarihi': function (value1) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this
            .Bilet
            .GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {
            var paramsgetexpritydate = {
              SatisTarihi: value1,
              UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
              CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
              SirketKodu: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              if (String(response.body) != "0001-01-01T00:00:00") {

                this.Bilet.TarihBilgileri.OdemeTarihi = response.body
              }

            })
          }

        }
      },
      'Bilet.GenelBilgileri.UcusTipi': function (value2) {
        if (value2 == 'I') {
          this.ichatmi = true
          this.dishatmi = false
        } else if (value2 == 'D' || value2 == 'D') {
          this.dishatmi = true
          this.ichatmi = false
        }


      },
      'Bilet.OdemeBilgileri.SatisSekli': function (value3) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

          this.bankaposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
          this.taksitsayi = []
          this.servisposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []
          this.kredikartishow = false
          this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

          this.slipnoshow = false
          this.Bilet.OdemeBilgileri.Slipkod = null

          this.makbuznoshow = false
          this.Bilet.OdemeBilgileri.MakbuzNo = null
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
          this.servisposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []

          this.bankaposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
          this.taksitsayi = []


          this.kredikartishow = false
          this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

          this.slipnoshow = false
          this.Bilet.OdemeBilgileri.Slipkod = null
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
          this.servisposshow = false
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
          this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
          this.taksitsayiservis = []


          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
          this.servisposshow = true
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {

          this.servisposshow = true
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }



      },
    }
  }

  function tutarTopla() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutar =
      (this.Bilet.TutarBilgileri.Tutar.Tutar +
        this.Bilet.TutarBilgileri.PtaTutar.PtaTutar +
        this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar +
        this.Bilet.TutarBilgileri.TaxTutar.TaxTutar +
        this.Bilet.TutarBilgileri.YFFTutar.YFFTutar +
        this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar +
        this.Bilet.TutarBilgileri.CezaTutar.CezaTutar +
        this.Bilet.TutarBilgileri.ServisTutar.ServisTutar +
        this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar +
        this.Bilet.TutarBilgileri.CharterTutar.CharterTutar +
        this.Bilet.TutarBilgileri.KaTutar.KaTutar) -
      this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar

    this.Bilet.TutarBilgileri.NetTutar.NetTutar = Math.round(this.Bilet.TutarBilgileri.NetTutar.NetTutar * 100) / 100
  }

  function tutarToplaSatisDoviz() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz =
      (this.Bilet.TutarBilgileri.Tutar.TutarSatisDoviz +
        this.Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz +
        this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz +
        this.Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz +
        this.Bilet.TutarBilgileri.YFFTutar.YFFDoviz +
        this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz +
        this.Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar +
        this.Bilet.TutarBilgileri.ServisTutar.ServisDoviz +
        this.Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz +
        this.Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz +
        this.Bilet.TutarBilgileri.KaTutar.KaDoviz) -
      this.Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz
  }

  function tutarToplaAlisDoviz() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutarAlisDoviz =
      this.Bilet.TutarBilgileri.Tutar.TutarAlisDoviz +
      this.Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz +
      this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz +
      this.Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar +
      this.Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz
  }

  function iadeiptal(m) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var paramsiade = {
      SirketKodu: credentials.SirketKodu,
      BiletNo: m.GenelBilgileri.BiletNo,
      FormNo: m.GenelBilgileri.Formno,
      SiraNo: m.GenelBilgileri.Sirano,
      IadeTarihi: m.TarihBilgileri.IadeTarihi,
    }

    this.$http.post(auth.API_URL + 'api/Ticket/RefundDelete', paramsiade, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true


      var iadeparams = {

        SirketKodu: credentials.SirketKodu,
        HavaYoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
        FormNo: this.Bilet.GenelBilgileri.Formno,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        Sirano: 0,
        BaslangicTarihi: null,
        BitisTarihi: null
      }

      this.$http.post(auth.API_URL + 'api/Ticket/RefundList', iadeparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.iadeitems = response.body

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Bilet İade List'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Bilet İade List'
          this.snackbar = true
        }
      })



    }, (response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    })
  }

  function coklubiletkayit() {
    this.toplubilet = [];
    var controlaa = 1;
    var hatalikayit = null;
    this.objeler.forEach(element => {
      var yeniveri = {}
      var element1 = document.getElementById(element.vmodelname);
      if (element1 != null) {
        yeniveri['BiletNo'] = element.BiletNo
        yeniveri['YolcuAdi'] = element1.value
        this.toplubilet.push(yeniveri)
      }
    });

    this.toplubilet.forEach(element2 => {

      if (element2.YolcuAdi == null || element2.YolcuAdi == '') {
        controlaa = controlaa * 0;
      } else {
        controlaa = controlaa * 1;
      }
    });


    if (controlaa == 1) {
      this.cokluyolcudialog = false;
      this.yenidialog = false;
      this.biletnodisabled = true
      this.Bilet.GenelBilgileri.ArkmanUsers = null;
      this.Bilet.GenelBilgileri.Baglantili == false;
      this.yolcudisabled = true;

      this.bekletme = true;

    } else {
      this.text1 = 'Lütfen tüm alanları eksiksiz doldurunuz.';
      this.snackbar = true;
      this.yolcudisabled = false;
    }
  }



  function tahsilatkaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
    this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
    this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
    this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
    this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
    this.BiletAyrintiliOdeme.Faturano = this.Bilet.FaturaBilgileri.FaturaNo
    this.BiletAyrintiliOdeme.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarih
    this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri

    var paramstahsilat = this.BiletAyrintiliOdeme
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.tahsilatdialog = false


      var tahsilatparams = {

        SirketKodu: credentials.SirketKodu,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        FormNo: this.Bilet.GenelBilgileri.Formno,
        BA: 1
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.tahsilatitems = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }

  function faturakaydet() {


    if (this.Fatura.FaturaTarih != null && this.Fatura.FaturaTarih != '') {

      if (this.Fatura.FaturaSeri != null && this.Fatura.FaturaSeri != '') {

        if (this.Fatura.FaturaNo != null && this.Fatura.FaturaNo != '') {

          if (this.Fatura.GibSeri != null && this.Fatura.GibSeri != '') {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.Fatura.SirketKodu = credentials.SirketKodu
            this.Fatura.BiletBilgi.BiletNo = this.Bilet.GenelBilgileri.BiletNo
            this.Fatura.BiletBilgi.FormNo = this.Bilet.GenelBilgileri.Formno
            this.Fatura.BiletBilgi.UcusTip = this.Bilet.GenelBilgileri.UcusTipi
            this.Fatura.BiletBilgi.OdemeTarihi = this.Bilet.TarihBilgileri.OdemeTarihi

            var deneme = []
            deneme = this.Bilet.GenelBilgileri.MusteriKodu
            this.Fatura.BiletBilgi.CariKod = deneme
            this.Fatura.BiletBilgi.NetTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar


            var paramsfatura = this.Fatura

            this.$http.post(auth.API_URL + 'api/TicketInvoice/TicketInvoiceAdd', paramsfatura, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              if (response.body.FaturaStatus == true) {
                this.faturadialog = false
                this.text1 = response.body.FaturaResponse
                this.snackbar = true

                var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                  '&biletno=' +
                  this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi + '&tab=0'
                window.open(url, '_self')

                setTimeout(function () {
                  window.location.reload(false);
                }.bind(this), 3000)

              } else {
                this.text1 = response.body.FaturaResponse
                this.snackbar = true
              }

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.body.StatusText
                this.snackbar = true
              }
            })

          } else {
            this.text1 = 'Lütfen bir gib serisi seçiniz'
            this.snackbar = true
          }
        } else {
          this.text1 = 'Lütfen bir fatura no giriniz'
          this.snackbar = true
        }
      } else {
        this.text1 = 'Lütfen bir fatura seri giriniz'
        this.snackbar = true
      }

    } else {
      this.text1 = 'Lütfen fatura tarihini giriniz'
      this.snackbar = true
    }

  }


  function tahsilatsil(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var paramstahsilat = {
        SirketKodu: credentials.SirketKodu,
        OdemeKod: deger.OdemeKod,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        FormNo: this.Bilet.GenelBilgileri.Formno,
        Nereden: deger.Nereden,
        TanimID: deger.TanimID
      }

      this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentDelete', paramstahsilat, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false


        var tahsilatparams = {

          SirketKodu: credentials.SirketKodu,
          BiletNo: this.Bilet.GenelBilgileri.BiletNo,
          FormNo: this.Bilet.GenelBilgileri.Formno,
          BA: 1
        }

        this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.tahsilatitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })



      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.StatusText
          this.snackbar = true
        }
      })

    } else {
      this.kisamesaj = 'Bu kayıt cari hareket girişinden gelmiştir, işlem yapamazsınız!'
      this.dialogkisamesaj = true
    }
  }



  function tahsilatgetir(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {


      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.BiletAyrintiliOdeme.OdemeKod = deger.OdemeKod
      this.BiletAyrintiliOdeme.TanimID = deger.TanimID
      this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
      this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
      this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
      this.BiletAyrintiliOdeme.Nereden = deger.Nereden
      this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
      this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
      this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
      this.BiletAyrintiliOdeme.Faturano = deger.FaturaNo
      this.BiletAyrintiliOdeme.FaturaTarih = deger.FaturaTarih
      this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri
      this.BiletAyrintiliOdeme.Tarih = deger.Tarih
      this.BiletAyrintiliOdeme.EvrakCinsi = deger.Evrak.Evrakkod
      this.BiletAyrintiliOdeme.Doviz = deger.DovizCinsi
      this.BiletAyrintiliOdeme.Kur = deger.Kur
      this.BiletAyrintiliOdeme.Tutar = deger.Tutar
      this.BiletAyrintiliOdeme.DovizTutar = deger.DovizTutar
      this.BiletAyrintiliOdeme.PosKod = deger.PosKod
      this.BiletAyrintiliOdeme.EvrakNo = deger.Evrakno
      this.BiletAyrintiliOdeme.KrediKartNo = deger.KrediKartNo
      this.BiletAyrintiliOdeme.Aciklama = deger.Aciklama
      this.BiletAyrintiliOdeme.TaksitKod = deger.TaksitID
      this.BiletAyrintiliOdeme.TaksitKodLabel = deger.TaksitKodLabel
      this.BiletAyrintiliOdeme.PuanTutar = deger.PuanTutar
      this.BiletAyrintiliOdeme.BankaKod = deger.BankaKod
      this.BiletAyrintiliOdeme.KarsiCari = deger.KarsiCari

      this.$refs.tahsilatdialog1.open("update").then(sonuc => {
        if (sonuc == true) {

          //kayıt başarılı ise listeyi güncelleyelim

          var tahsilatparams = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            BA: 1
          }
          this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.tahsilatitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      });
    } else {
      this.kisamesaj = 'Bu kayıt cari hareket girişinden gelmiştir, işlem yapamazsınız!'
      this.dialogkisamesaj = true
    }

  }

  function tahsilatguncelle(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {
      paramstahsilat = this.BiletAyrintiliOdeme

      this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false


        var tahsilatparams = {

          SirketKodu: credentials.SirketKodu,
          BiletNo: this.Bilet.GenelBilgileri.BiletNo,
          FormNo: this.Bilet.GenelBilgileri.Formno,
          BA: 1
        }

        this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.tahsilatitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.StatusText
          this.snackbar = true
        }
      })

    } else {
      this.kisamesaj = 'Bu kayıt cari hareket girişinden gelmiştir, işlem yapamazsınız!'
      this.dialogkisamesaj = true
    }
  }


  function tarihformatla(datem) {
    var gun = datem.getDate();
    var ay = datem.getMonth() + 1;
    var yil = datem.getFullYear();

    if (ay < 10) {
      ay = '0' + ay
    }
    if (gun < 10) {
      gun = '0' + gun
    }

    return yil + "-" + ay + "-" + gun;

  }





  function voidislem() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var paramsvoid = {
      SirketKodu: credentials.SirketKodu,
      BiletNo: this.Bilet.GenelBilgileri.BiletNo,
      HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
      Formno: this.Bilet.GenelBilgileri.Formno,
      UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
      // Login: {eklenecek},
      IssueDate: getDateNow()
    }

    this.$http.post(auth.API_URL + 'api/Ticket/VoidAdd', paramsvoid, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = 'Void işlemi tamamlandı.'
      this.snackbar = true
      setTimeout(function () {
        this.sayfakapat()
      }.bind(this), 3000)
      this.voiddialog = false
    }, (response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    })
  }

  function voidiptal() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var paramsvoid = {
      SirketKodu: credentials.SirketKodu,
      BiletNo: this.Bilet.GenelBilgileri.BiletNo,
      HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
      Formno: this.Bilet.GenelBilgileri.Formno,
      UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
      IssueDate: this.Bilet.TarihBilgileri.SatisTarihi
    }

    this.$http.post(auth.API_URL + 'api/Ticket/VoidCancel', paramsvoid, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = 'Void iptal işlemi tamamlandı.'
      this.snackbar = true
      setTimeout(function () {
        this.sayfakapat()
      }.bind(this), 3000)

    }, (response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    })
  }

  function biletkaydet() {



    if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {

      if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '') {

        if (this.Bilet.TarihBilgileri.OdemeTarihi != null && this.Bilet.TarihBilgileri.OdemeTarihi != '') {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.Bilet.GenelBilgileri.SirketKodu = credentials.SirketKodu
          var yeniucuslistesi = []


          if (this.UcusListesi.Ucus1.FareBases != 0 ||
            (this.UcusListesi.Ucus1.Parkur != '' && this.UcusListesi.Ucus1.Parkur != null) ||
            (this.UcusListesi.Ucus1.ParkurNo != '' && this.UcusListesi.Ucus1.ParkurNo != null) ||
            (this.UcusListesi.Ucus1.UcusClass != '' && this.UcusListesi.Ucus1.UcusClass != null) ||
            (this.UcusListesi.Ucus1.UcusHY != '' && this.UcusListesi.Ucus1.UcusHY != null) ||
            (this.UcusListesi.Ucus1.UcusNo != '' && this.UcusListesi.Ucus1.UcusNo != null) ||
            (this.UcusListesi.Ucus1.UcusSaat != '' && this.UcusListesi.Ucus1.UcusSaat != null) ||
            (this.UcusListesi.Ucus1.UcusTarihi != '' && this.UcusListesi.Ucus1.UcusTarihi != null) ||
            (this.UcusListesi.Ucus1.VarisSaat != '' && this.UcusListesi.Ucus1.VarisSaat != null) ||
            (this.UcusListesi.Ucus1.VarisTarihi != '' && this.UcusListesi.Ucus1.VarisTarihi != null)) {

            var ucuslistesi1 = {
              Aktarma: this.UcusListesi.Ucus1.Aktarma,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FareBases: this.UcusListesi.Ucus1.FareBases,
              Formno: this.Bilet.GenelBilgileri.Formno,
              ID: this.UcusListesi.Ucus1.ID,
              Parkur: this.UcusListesi.Ucus1.Parkur,
              ParkurNo: this.UcusListesi.Ucus1.ParkurNo,
              SirketKodu: credentials.SirketKodu,
              UcusClass: this.UcusListesi.Ucus1.UcusClass,
              UcusHY: this.UcusListesi.Ucus1.UcusHY,
              UcusNo: this.UcusListesi.Ucus1.UcusNo,
              UcusSaat: this.UcusListesi.Ucus1.UcusSaat,
              UcusTarihi: this.UcusListesi.Ucus1.UcusTarihi,
              VarisSaat: this.UcusListesi.Ucus1.VarisSaat,
              VarisTarihi: this.UcusListesi.Ucus1.VarisTarihi
            }
            yeniucuslistesi.push(ucuslistesi1)
          }

          if (this.UcusListesi.Ucus2.FareBases != 0 ||
            (this.UcusListesi.Ucus2.Parkur != '' && this.UcusListesi.Ucus2.Parkur != null) ||
            (this.UcusListesi.Ucus2.ParkurNo != '' && this.UcusListesi.Ucus2.ParkurNo != null) ||
            (this.UcusListesi.Ucus2.UcusClass != '' && this.UcusListesi.Ucus2.UcusClass != null) ||
            (this.UcusListesi.Ucus2.UcusHY != '' && this.UcusListesi.Ucus2.UcusHY != null) ||
            (this.UcusListesi.Ucus2.UcusNo != '' && this.UcusListesi.Ucus2.UcusNo != null) ||
            (this.UcusListesi.Ucus2.UcusSaat != '' && this.UcusListesi.Ucus2.UcusSaat != null) ||
            (this.UcusListesi.Ucus2.UcusTarihi != '' && this.UcusListesi.Ucus2.UcusTarihi != null) ||
            (this.UcusListesi.Ucus2.VarisSaat != '' && this.UcusListesi.Ucus2.VarisSaat != null) ||
            (this.UcusListesi.Ucus2.VarisTarihi != '' && this.UcusListesi.Ucus2.VarisTarihi != null)) {

            var ucuslistesi2 = {
              Aktarma: this.UcusListesi.Ucus2.Aktarma,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FareBases: this.UcusListesi.Ucus2.FareBases,
              Formno: this.Bilet.GenelBilgileri.Formno,
              ID: this.UcusListesi.Ucus2.ID,
              Parkur: this.UcusListesi.Ucus2.Parkur,
              ParkurNo: this.UcusListesi.Ucus2.ParkurNo,
              SirketKodu: credentials.SirketKodu,
              UcusClass: this.UcusListesi.Ucus2.UcusClass,
              UcusHY: this.UcusListesi.Ucus2.UcusHY,
              UcusNo: this.UcusListesi.Ucus2.UcusNo,
              UcusSaat: this.UcusListesi.Ucus2.UcusSaat,
              UcusTarihi: this.UcusListesi.Ucus2.UcusTarihi,
              VarisSaat: this.UcusListesi.Ucus2.VarisSaat,
              VarisTarihi: this.UcusListesi.Ucus2.VarisTarihi
            }
            yeniucuslistesi.push(ucuslistesi2)
          }

          if (this.UcusListesi.Ucus3.FareBases != 0 ||
            (this.UcusListesi.Ucus3.Parkur != '' && this.UcusListesi.Ucus3.Parkur != null) ||
            (this.UcusListesi.Ucus3.ParkurNo != '' && this.UcusListesi.Ucus3.ParkurNo != null) ||
            (this.UcusListesi.Ucus3.UcusClass != '' && this.UcusListesi.Ucus3.UcusClass != null) ||
            (this.UcusListesi.Ucus3.UcusHY != '' && this.UcusListesi.Ucus3.UcusHY != null) ||
            (this.UcusListesi.Ucus3.UcusNo != '' && this.UcusListesi.Ucus3.UcusNo != null) ||
            (this.UcusListesi.Ucus3.UcusSaat != '' && this.UcusListesi.Ucus3.UcusSaat != null) ||
            (this.UcusListesi.Ucus3.UcusTarihi != '' && this.UcusListesi.Ucus3.UcusTarihi != null) ||
            (this.UcusListesi.Ucus3.VarisSaat != '' && this.UcusListesi.Ucus3.VarisSaat != null) ||
            (this.UcusListesi.Ucus3.VarisTarihi != '' && this.UcusListesi.Ucus3.VarisTarihi != null)) {
            var ucuslistesi3 = {
              Aktarma: this.UcusListesi.Ucus3.Aktarma,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FareBases: this.UcusListesi.Ucus3.Bases,
              Formno: this.Bilet.GenelBilgileri.Formno,
              ID: this.UcusListesi.Ucus3.ID,
              Parkur: this.UcusListesi.Ucus3.Parkur,
              ParkurNo: this.UcusListesi.Ucus3.ParkurNo,
              SirketKodu: credentials.SirketKodu,
              UcusClass: this.UcusListesi.Ucus3.UcusClass,
              UcusHY: this.UcusListesi.Ucus3.UcusHY,
              UcusNo: this.UcusListesi.Ucus3.UcusNo,
              UcusSaat: this.UcusListesi.Ucus3.UcusSaat,
              UcusTarihi: this.UcusListesi.Ucus3.UcusTarihi,
              VarisSaat: this.UcusListesi.Ucus3.VarisSaat,
              VarisTarihi: this.UcusListesi.Ucus3.VarisTarihi
            }
            yeniucuslistesi.push(ucuslistesi3)
          }

          if (this.UcusListesi.Ucus4.FareBases != 0 ||
            (this.UcusListesi.Ucus4.Parkur != '' && this.UcusListesi.Ucus4.Parkur != null) ||
            (this.UcusListesi.Ucus4.ParkurNo != '' && this.UcusListesi.Ucus4.ParkurNo != null) ||
            (this.UcusListesi.Ucus4.UcusClass != '' && this.UcusListesi.Ucus4.UcusClass != null) ||
            (this.UcusListesi.Ucus4.UcusHY != '' && this.UcusListesi.Ucus4.UcusHY != null) ||
            (this.UcusListesi.Ucus4.UcusNo != '' && this.UcusListesi.Ucus4.UcusNo != null) ||
            (this.UcusListesi.Ucus4.UcusSaat != '' && this.UcusListesi.Ucus4.UcusSaat != null) ||
            (this.UcusListesi.Ucus4.UcusTarihi != '' && this.UcusListesi.Ucus4.UcusTarihi != null) ||
            (this.UcusListesi.Ucus4.VarisSaat != '' && this.UcusListesi.Ucus4.VarisSaat != null) ||
            (this.UcusListesi.Ucus4.VarisTarihi != '' && this.UcusListesi.Ucus4.VarisTarihi != null)) {
            var ucuslistesi4 = {
              Aktarma: this.UcusListesi.Ucus4.Aktarma,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FareBases: this.UcusListesi.Ucus4.FareBases,
              Formno: this.Bilet.GenelBilgileri.Formno,
              ID: this.UcusListesi.Ucus4.ID,
              Parkur: this.UcusListesi.Ucus4.Parkur,
              ParkurNo: this.UcusListesi.Ucus4.ParkurNo,
              SirketKodu: credentials.SirketKodu,
              UcusClass: this.UcusListesi.Ucus4.UcusClass,
              UcusHY: this.UcusListesi.Ucus4.UcusHY,
              UcusNo: this.UcusListesi.Ucus4.UcusNo,
              UcusSaat: this.UcusListesi.Ucus4.UcusSaat,
              UcusTarihi: this.UcusListesi.Ucus4.UcusTarihi,
              VarisSaat: this.UcusListesi.Ucus4.VarisSaat,
              VarisTarihi: this.UcusListesi.Ucus4.VarisTarihi
            }
            yeniucuslistesi.push(ucuslistesi4)
          }

          if (this.UcusListesi.Ucus5.FareBases != 0 ||
            (this.UcusListesi.Ucus5.Parkur != '' && this.UcusListesi.Ucus5.Parkur != null) ||
            (this.UcusListesi.Ucus5.ParkurNo != '' && this.UcusListesi.Ucus5.ParkurNo != null) ||
            (this.UcusListesi.Ucus5.UcusClass != '' && this.UcusListesi.Ucus5.UcusClass != null) ||
            (this.UcusListesi.Ucus5.UcusHY != '' && this.UcusListesi.Ucus5.UcusHY != null) ||
            (this.UcusListesi.Ucus5.UcusNo != '' && this.UcusListesi.Ucus5.UcusNo != null) ||
            (this.UcusListesi.Ucus5.UcusSaat != '' && this.UcusListesi.Ucus5.UcusSaat != null) ||
            (this.UcusListesi.Ucus5.UcusTarihi != '' && this.UcusListesi.Ucus5.UcusTarihi != null) ||
            (this.UcusListesi.Ucus5.VarisSaat != '' && this.UcusListesi.Ucus5.VarisSaat != null) ||
            (this.UcusListesi.Ucus5.VarisTarihi != '' && this.UcusListesi.Ucus5.VarisTarihi != null)) {
            var ucuslistesi5 = {
              Aktarma: this.UcusListesi.Ucus5.Aktarma,
              BiletNo: this.Bilet.GenelBilgileri.BiletNo,
              FareBases: this.UcusListesi.Ucus5.FareBases,
              Formno: this.Bilet.GenelBilgileri.Formno,
              ID: this.UcusListesi.Ucus5.ID,
              Parkur: this.UcusListesi.Ucus5.Parkur,
              ParkurNo: this.UcusListesi.Ucus5.ParkurNo,
              SirketKodu: credentials.SirketKodu,
              UcusClass: this.UcusListesi.Ucus5.UcusClass,
              UcusHY: this.UcusListesi.Ucus5.UcusHY,
              UcusNo: this.UcusListesi.Ucus5.UcusNo,
              UcusSaat: this.UcusListesi.Ucus5.UcusSaat,
              UcusTarihi: this.UcusListesi.Ucus5.UcusTarihi,
              VarisSaat: this.UcusListesi.Ucus5.VarisSaat,
              VarisTarihi: this.UcusListesi.Ucus5.VarisTarihi
            }
            yeniucuslistesi.push(ucuslistesi5)
          }

          this.Bilet.UcusBilgileri.UcusListesi = yeniucuslistesi

          //net tutarı hesaplıyoruz
          // this.Bilet.TutarBilgileri.NetTutar.NetTutar = this.Bilet.TutarBilgileri.Tutar.Tutar + this.Bilet.TutarBilgileri
          //   .YFFTutar.YFFTutar +
          //   this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar + this.Bilet.TutarBilgileri.ServisTutar.ServisTutar +
          //   this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar + this.Bilet.TutarBilgileri.CezaTutar.CezaTutar + this.Bilet
          //   .TutarBilgileri.PtaTutar.PtaTutar - this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar

          //satış şekline göre tutarları yazıyoruz
          if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {
            this.Bilet.OdemeBilgileri.KrediliTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.PesinTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = null
          } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
            this.Bilet.OdemeBilgileri.PesinTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.KrediliTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartTutar = 0
            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'P'

          } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'R' || this.Bilet.OdemeBilgileri.SatisSekli == 'C' ||
            this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
            if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'R'
            } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'C'
            } else {
              this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'R'
              this.Bilet.OdemeBilgileri.SatisSekli = 'R'
            }

            this.Bilet.OdemeBilgileri.KrediKartTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.Bilet.OdemeBilgileri.KrediliTutar = 0
            this.Bilet.OdemeBilgileri.PesinTutar = 0
          }


          if (this.biletcoklumu == false) {
            var paramsbilet = this.Bilet

            this.$http.post(auth.API_URL + 'api/Ticket/TicketAdd', paramsbilet, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.text1 = response.body.ResponseMessage
              this.snackbar = true
              if (response.body.Status != Boolean(false)) {
                this.faturabtn = false
                // setTimeout(function () {
                //   this.sayfakapat()
                // }.bind(this), 3000)
              }

            }, (response) => {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true

              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              }
            })
          }

          if (this.biletcoklumu == true) {

            var biletdurum = false;

            this.toplubilet.forEach(element => {
              this.Bilet.GenelBilgileri.BiletNo = element.BiletNo;
              this.Bilet.GenelBilgileri.YolcuAdi = element.YolcuAdi;
              var paramsbilet = this.Bilet
              this.$http.post(auth.API_URL + 'api/Ticket/TicketAdd', paramsbilet, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {

                this.text1 = response.body.ResponseMessage
                this.snackbar = true

                if (response.body.Status == true) {


                  biletdurum = true;
                }
                if (response.body.Status == false) {
                  biletdurum = false;
                }
              }, (response) => {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true


                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                } else {
                  this.text1 = response.body.ResponseMessage
                  this.snackbar = true
                }
              })

            });
            setTimeout(function () {
              this.sayfakapat()
            }.bind(this), 3000)
          }
        } else {
          this.text1 = 'Lütfen ödeme tarihini giriniz'
          this.snackbar = true
        }
      } else {
        this.text1 = 'Lütfen satış tarihini giriniz'
        this.snackbar = true
      }
    } else {
      this.text1 = 'Lütfen bir cari kod seçiniz'
      this.snackbar = true
    }
  }

  function biletislemsorgula() {

    if (this.Bilet.GenelBilgileri.Baglantili == false) {

      var control1 = false

      if (this.Bilet.GenelBilgileri.BiletNo != null && this.Bilet.GenelBilgileri.BiletNo != '') {


        if (this.Bilet.GenelBilgileri.HavaYoluKodu != null && this.Bilet.GenelBilgileri.HavaYoluKodu != '') {


          if (this.Bilet.GenelBilgileri.UcusTipi != null && this.Bilet.GenelBilgileri.UcusTipi != '') {


            if (this.Bilet.GenelBilgileri.AcenteKodu != '' && this.Bilet.GenelBilgileri.AcenteKodu != null && this.Bilet
              .GenelBilgileri
              .Acente == 'A') {
              control1 = true
              this.baslik_mesaji = '(Bu bilet acentadan alınmıştır)'

            } else if (this.acentabiletimi === false) {
              control1 = true
              this.Bilet.GenelBilgileri.AcenteKodu = ''
              this.baslik_mesaji = ''
              this.Bilet.GenelBilgileri.Acente = ''
            } else if (this.acentabiletimi === true && (this.Bilet.GenelBilgileri.AcenteKodu == '' || this.Bilet
                .GenelBilgileri
                .AcenteKodu == null)) {
              control1 = false
              this.baslik_mesaji = ''
              this.text1 = 'Lütfen acente seçimi yapınız...'
              this.snackbar = true
              this.Bilet.GenelBilgileri.AcenteKodu = ''
              this.Bilet.GenelBilgileri.Acente = ''
            }
          } else {
            this.text1 = 'Lütfen uçuş tipini seçiniz...'
            this.snackbar = true
            control1 = false
          }
        } else {
          this.text1 = 'Lütfen hava yolu kodunu seçiniz...'
          this.snackbar = true
          control1 = false
        }
      } else {
        this.text1 = 'Lütfen bilet numarasını eksiksiz giriniz...'
        this.snackbar = true
        control1 = false
      }



      if (control1 === true) {


        // işlem yapmak için üyelik durumuna bakıyoruz

        var islemok = false

        if (this.Uyelik.UyelikStatus == true) {

          if (this.Uyelik.UyelikTip == 3) {

            if (this.Uyelik.KalanKontor > 1) {
              console.log('kalankontor' + this.Uyelik.KalanKontor)
              islemok = true
            } else {
              this.islemok = false
              this.text1 =
                'İşleminiz için yeterli kontörünüz bulunmamaktadır. İşleminize devam etmek için üyeliğinizi yenilemeniz gerekmektedir.'
              this.snackbar = true
            }
          } else if (this.Uyelik.UyelikTip == 1 || this.Uyelik.UyelikTip == 2) {
            islemok = true
          }
        } else {
          this.text1 =
            'Üyeliğiniz bitmiştir. İşleminize devam etmek için üyeliğinizi yenilemeniz gerekmektedir.'
          this.snackbar = true
          islemok = false
        }


        if (islemok == true) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          var paramssorgu = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
            Formno: this.Bilet.GenelBilgileri.Formno,
            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi
          }
          this.$http.post(auth.API_URL + 'api/Ticket/TicketControl', paramssorgu, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body == 'Bos') {

              this.yenidialog = false
              this.biletnodisabled = true
              this.kaydetbuton = true
              this.bekletme = true;
            } else {
              this.text1 = 'Bilet numarası uygun işlem yapmak için uygun değildir.'
              this.snackbar = true
              this.bekletme = false;
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.body.StatusText
              this.snackbar = true
            }
          })

        }
      }
    } else {

      var control2 = false;

      if (this.Bilet.GenelBilgileri.BiletNo != null && this.Bilet.GenelBilgileri.BiletNo != '' && this.Bilet
        .GenelBilgileri
        .ArkmanUsers != '' && this.Bilet.GenelBilgileri.ArkmanUsers != null) {


        if (this.Bilet.GenelBilgileri.HavaYoluKodu != null && this.Bilet.GenelBilgileri.HavaYoluKodu != '') {


          if (this.Bilet.GenelBilgileri.UcusTipi != null && this.Bilet.GenelBilgileri.UcusTipi != '') {


            if (this.Bilet.GenelBilgileri.AcenteKodu != '' && this.Bilet.GenelBilgileri.AcenteKodu != null && this.Bilet
              .GenelBilgileri.Acente == 'A') {
              control2 = true
              this.baslik_mesaji = '(Bu bilet acentadan alınmıştır)'

            } else if (this.acentabiletimi === false) {
              control2 = true
              this.Bilet.GenelBilgileri.AcenteKodu = ''
              this.baslik_mesaji = ''
              this.Bilet.GenelBilgileri.Acente = ''
            } else if (this.acentabiletimi === true && (this.Bilet.GenelBilgileri.AcenteKodu == '' || this.Bilet
                .GenelBilgileri
                .AcenteKodu == null)) {
              control2 = false
              this.baslik_mesaji = ''
              this.text1 = 'Lütfen acente seçimi yapınız...'
              this.snackbar = true
              this.Bilet.GenelBilgileri.AcenteKodu = ''
              this.Bilet.GenelBilgileri.Acente = ''
            }
          } else {
            this.text1 = 'Lütfen uçuş tipini seçiniz...'
            this.snackbar = true
            control2 = false
          }
        } else {
          this.text1 = 'Lütfen hava yolu kodunu seçiniz...'
          this.snackbar = true
          control2 = false

        }
      } else {
        this.text1 = 'Lütfen bilet numaralarını eksiksiz giriniz...'
        this.snackbar = true
        control2 = false
      }

      if (control2 === true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var kacbilet = this.Bilet.GenelBilgileri.ArkmanUsers - this.Bilet.GenelBilgileri.BiletNo


        // işlem yapmak için üyelik durumuna bakıyoruz


        var islemok = false

        if (this.Uyelik.UyelikStatus == true) {

          if (this.Uyelik.UyelikTip == 3) {

            if (this.Uyelik.KalanKontor >= kacbilet) {
              islemok = true
            } else {
              this.islemok = false
              this.text1 =
                'İşleminiz için yeterli kontörünüz bulunmamaktadır. İşleminize devam etmek için üyeliğinizi yenilemeniz gerekmektedir.'
              this.snackbar = true
            }
          } else if (this.Uyelik.UyelikTip == 1 || this.Uyelik.UyelikTip == 2) {
            islemok = true
          }
        } else {
          this.text1 =
            'Üyeliğiniz bitmiştir. İşleminize devam etmek için üyeliğinizi yenilemeniz gerekmektedir.'
          this.snackbar = true
          islemok = false
        }


        if (islemok == true) {
          var paramssorgu1 = {
            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            BiletNoSon: this.Bilet.GenelBilgileri.ArkmanUsers,
            HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
            Formno: this.Bilet.GenelBilgileri.Formno,
            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi
          }
          this.$http.post(auth.API_URL + 'api/Ticket/TicketControlGroup', paramssorgu1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body.ResponseInfo.Status == true) {
              var i = 1;
              var yenikayit = []
              response.body.BiletList.forEach(element => {
                var NewObject = {};
                NewObject['Label'] = i + '. Yolcu Adı Soyadı';
                NewObject['BiletNo'] = element.BiletNo;
                NewObject['vmodelname'] = 'vmodel' + i;
                yenikayit.push(NewObject)
                i = i + 1;
              });

              this.objeler = yenikayit
              this.biletcoklumu = true;
              this.cokluyolcudialog = true
            } else {
              this.biletcoklumu = false;
              this.text1 = response.body.ResponseInfo.ResponseMessage;
              this.snackbar = true
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.body.StatusText
              this.snackbar = true
            }
          })
        }
      }
    }
  }



  function taksitgetirservis(v) {

    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

      if (element.PosKodu == v) {

        this.taksitsayiservis = []
        this.taksitsayiservis = element.Taksitler
      }
      this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = parseInt(this.servistaksitsayi)
    });
  }

  function taksitgetirtahsilat(v) {

    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

      if (element.PosKodu == v) {

        this.taksitsayitahsilat = []
        this.taksitsayitahsilat = element.Taksitler
      }


    });
  }

  function taksitgetir(v) {

    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

      if (element.PosKodu == v) {

        this.taksitsayi = []
        this.taksitsayi = element.Taksitler

      }
    });
    this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = parseInt(this.postaksitsayi)

  }

  function caribilgigetir(a) {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var CurrentInput = {
      Code: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.eFaturaBilgi = response.body.EInvoiceCustomer
      this.Bilet.GenelBilgileri.MusteriKodu.Unvan = response.body.Title
      this.Fatura.EFaturaBilgi.Unvani = response.body.Title
      this.Fatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
      this.Fatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
      this.Fatura.EFaturaBilgi.Email = response.body.Email
      this.Fatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
      this.Fatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
      this.Fatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
      this.Fatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
      this.Fatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
      this.Fatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
      this.Fatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
      this.Fatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix
      this.Bilet.GenelBilgileri.MusteriKodu.Uyari = response.body.WarningNote
      if (response.body.EArchiveSendType == true) {
        this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 1;
      } else {
        this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 0;
      }


      //0 ise Earşiv / 1 ise gib seri

      if (response.body.EInvoiceType == 1) {
        this.earsivseridurum = 1
      }

      if (response.body.EInvoiceType == 0) {
        this.earsivseridurum = 0
      }





      if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this.Bilet
        .GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
          var paramsgetexpritydate = {
            SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
            CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
            SirketKodu: credentials.SirketKodu,
          }
          this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (String(response.body) != "0001-01-01T00:00:00") {
              this.Bilet.TarihBilgileri.OdemeTarihi = response.body
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }







  function carigetir(v) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      q: escape(v),
      c: credentials.SirketKodu
    }
    if (v.length >= 3) {
      this.loading = true
      this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.statecari = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
      this.loading = false
    }
  }

  function carigetir2(v) {

    this.statecaritahsilat = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      q: escape(v),
      c: credentials.SirketKodu
    }
    if (v.length >= 1) {
      this.loading = true
      this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.statecaritahsilat = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
      this.loading = false
    }
  }


  function servisgetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.servisclass.SirketKodu = credentials.SirketKodu
    this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
    this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
    this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
    this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
    this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
    this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5

    var params1 = this.servisclass

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.servisitems = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
    this.servisdialog = true
  }


  function serviscodeControl() {

    if (this.val != null && this.val != '') {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
        Type: 307,
        ID: escape(this.val),
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.length == 1) {
          this.val = response.body[0].ID
          this.kodmesajı = null
        } else {
          this.kodmesajı = 'Hatalı kod girişi..'
          this.val = null
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-analizkodu'
          this.snackbar = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable-analizkodu'
          this.snackbar = true
          this.progress = false
        }
      })
    } else {
      this.kodmesajı = null
    }
  }



  function beforeMount() {

    this.Bilet.GenelBilgileri.ArkmanUsers = null;

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.classitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      }
    })



    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.RezTutarEtiket = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-bankpos'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
        this.progress = false
      }
    })



    if (this.$route.query.isl == 'get') {

      this.loadingdialog = true


      var biletparams = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.$route.query.biletno,
        HavaYoluKodu: this.$route.query.hyolukod,
        UcusTipi: this.$route.query.ucustipi
      }

      this.loadingdialog = true
      this.biletnodisabled = true
      this.kaydetbuton = false
      this.guncellebtngorunum = true


      this.ucus1 = true
      this.ucus2 = true
      this.ucus3 = true
      this.ucus4 = true
      this.ucus5 = true


      this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.bekletme = true;

        if (response.body.OdemeBilgileri.SatisSekli == 'K' || response.body.OdemeBilgileri.SatisSekli == 'F') {
          this.tahsilatbtn = true
        }

        this.voiddurum = true

        var seciliitems = [{
          text: response.body.GenelBilgileri.MusteriKodu.Kod + '-' + response.body.GenelBilgileri.MusteriKodu
            .Unvan,
          id: response.body.GenelBilgileri.MusteriKodu.Kod
        }]

        this.statecari = seciliitems
        this.KrediLimiti = response.body.GenelBilgileri.MusteriKodu.KalanKrediLimit.toFixed(2).replace(
          /(\d)(?=(\d{3})+\.)/g, '$1,')


        this.Bilet.GenelBilgileri.Referans.Kod = String(response.body.GenelBilgileri.Referans.Kod)

        if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
          this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
        }

        this.postaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.TaksitKod

        this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

        this.Bilet = response.body

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

          this.bankaposshow = false
          this.servisposshow = false
          this.kredikartishow = false
          this.slipnoshow = false
          this.makbuznoshow = false
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
          this.servisposshow = false
          this.bankaposshow = false
          this.kredikartishow = false
          this.slipnoshow = false
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
          this.servisposshow = false
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
          this.servisposshow = true
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
          this.servisposshow = true
          this.bankaposshow = true
          this.kredikartishow = true
          this.slipnoshow = true
          this.makbuznoshow = true
        }

        this.UcusList = response.body.UcusBilgileri.UcusListesi

        // fatura no varsa güncellenemez void yapılamaz
        var fatno = response.body.FaturaBilgileri.FaturaNo
        if (fatno != null && fatno != 0) {
          this.guncellebuton = true
          this.faturabtn = true
          this.voiddurum = true
          this.voidbtn = false
          this.iadebnt = false
          this.faturanodisabled = true
        } else {
          this.faturanodisabled = false
          this.guncellebuton = false
          this.voiddurum = false
          this.guncellebuton = false
          this.faturabtn = false
          this.voidbtn = true
          this.iadebtn = true

        }

        if (response.body.GenelBilgileri.Acente == 'A') {
          this.baslik_mesaji = "(Bu bilet acenteden  alınmıştır.)"
        } else {
          this.baslik_mesaji = ""

        }

        if (this.UcusList.length > 0) {

          var i = 0
          this.UcusList.forEach(element => {

            if (i == 0 && i < this.UcusList.length) {
              this.ucus1 = true
              this.UcusListesi.Ucus1.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus1.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus1.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus1.FareBases = 0
              }

              this.UcusListesi.Ucus1.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus1.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus1.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus1.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus1.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus1.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus1.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus1.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus1.UcusSaat = this.UcusList[i].UcusSaat

              if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus1.UcusTarihi = null
              } else {
                this.UcusListesi.Ucus1.UcusTarihi = this.UcusList[i].UcusTarihi
              }


              this.UcusListesi.Ucus1.VarisSaat = this.UcusList[i].VarisSaat

              if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus1.VarisTarihi = null
              } else {
                this.UcusListesi.Ucus1.VarisTarihi = this.UcusList[i].UcusTarihi
              }


              i = i + 1
            }
            if (i == 1 && i < this.UcusList.length) {
              this.ucus2 = true
              this.UcusListesi.Ucus2.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus2.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus2.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus2.FareBases = 0
              }
              this.UcusListesi.Ucus2.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus2.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus2.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus2.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus2.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus2.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus2.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus2.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus2.UcusSaat = this.UcusList[i].UcusSaat

              if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus2.UcusTarihi = null
              } else {
                this.UcusListesi.Ucus2.UcusTarihi = this.UcusList[i].UcusTarihi
              }



              this.UcusListesi.Ucus2.VarisSaat = this.UcusList[i].VarisSaat

              if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus2.VarisTarihi = null
              } else {
                this.UcusListesi.Ucus2.VarisTarihi = this.UcusList[i].VarisTarihi
              }



              i = i + 1
            }
            if (i == 2 && i < this.UcusList.length) {
              this.ucus3 = true
              this.UcusListesi.Ucus3.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus3.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus3.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus3.FareBases = 0
              }
              this.UcusListesi.Ucus3.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus3.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus3.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus3.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus3.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus3.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus3.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus3.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus3.UcusSaat = this.UcusList[i].UcusSaat



              if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus3.UcusTarihi = null
              } else {
                this.UcusListesi.Ucus3.UcusTarihi = this.UcusList[i].UcusTarihi
              }



              this.UcusListesi.Ucus3.VarisSaat = this.UcusList[i].VarisSaat

              if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus3.VarisTarihi = null
              } else {
                this.UcusListesi.Ucus3.VarisTarihi = this.UcusList[i].VarisTarihi
              }


              i = i + 1
            }

            if (i == 3 && i < this.UcusList.length) {
              this.ucus4 = true
              this.UcusListesi.Ucus4.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus4.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus4.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus4.FareBases = 0
              }
              this.UcusListesi.Ucus4.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus4.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus4.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus4.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus4.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus4.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus4.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus4.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus4.UcusSaat = this.UcusList[i].UcusSaat

              if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus4.UcusTarihi = null
              } else {
                this.UcusListesi.Ucus4.UcusTarihi = this.UcusList[i].UcusTarihi
              }

              if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus4.VarisTarihi = null
              } else {
                this.UcusListesi.Ucus4.VarisTarihi = this.UcusList[i].VarisTarihi
              }



              this.UcusListesi.Ucus4.VarisSaat = this.UcusList[i].VarisSaat

              i = i + 1
            }

            if (i == 4 && i < this.UcusList.length) {
              this.ucus5 = true
              this.UcusListesi.Ucus5.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus5.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus5.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus5.FareBases = 0
              }
              this.UcusListesi.Ucus5.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus5.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus5.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus5.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus5.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus5.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus5.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus5.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus5.UcusSaat = this.UcusList[i].UcusSaat

              if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus5.VarisTarihi = null
              } else {
                this.UcusListesi.Ucus5.VarisTarihi = this.UcusList[i].VarisTarihi
              }

              if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                this.UcusListesi.Ucus5.UcusTarihi = null
              } else {
                this.UcusListesi.Ucus5.UcusTarihi = this.UcusList[i].UcusTarihi
              }

              this.UcusListesi.Ucus5.VarisSaat = this.UcusList[i].VarisSaat
              i = i + 1
            }
          });
        }

        if (response.body.FaturaBilgileri.FaturaNo != null && response.body.FaturaBilgileri.FaturaNo != '') {
          this.Fatura.FaturaTarih = response.body.FaturaBilgileri.FaturaTarihi
          this.Fatura.FaturaSeri = response.body.FaturaBilgileri.FaturaSeri
          this.Fatura.FaturaNo = response.body.FaturaBilgileri.FaturaNo
          this.faturanovarise = true
        }


        if (response.body.GenelBilgileri.Status == 'Ia') {

          this.iadetab = true

        } else {

          this.iadetab = false
        }
        this.loadingdialog = false

      }, (response) => {
        if (response.status === 0) {
          console.log('')
        } else {
          console.log('')
        }
      })

      if (this.$route.query.tab == 8) {
        this.active = '8'
      }

      if (this.$route.query.tab == 7) {
        this.active = '7'
      }



    } else if (this.$route.query.isl == 'yeni') {

      var params = {
        MusteriInfo: {
          MusteriKod: credentials.AnaSirketKodu
        }
      }


      this.$http.post(auth.API_URL + 'api/Register/ProductCustomerInfo', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.Uyelik = response.body

        this.uyeliktipi = response.body.UyelikTip;
        this.kalankontor = response.body.KalanKontor;

      }, (response) => {

        if (response.status === 0) {
          this.text1 = 'Service Unavailable-ProductCustomerInfo'
          this.snackbar = true

        } else {

          this.text1 = 'Service Unavailable-ProductCustomerInfo'
          this.snackbar = true

        }
      })





      this.faturabtn = true
      this.yenidialog = true
      this.Bilet.GenelBilgileri.ClassTip = null
      this.ucus1 = true
      this.ucus2 = true
      this.ucus3 = true
      this.ucus4 = true
      this.ucus5 = true

      this.voidbtn = false
      this.kaydetbuton = true
      this.guncellebtngorunum = false

      //K seçili olduğundan bunları yap
      this.bankaposshow = false
      this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
      this.taksitsayi = []
      this.servisposshow = false
      this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
      this.taksitsayiservis = []
      this.kredikartishow = false
      this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

      this.slipnoshow = false
      this.Bilet.OdemeBilgileri.Slipkod = null

      this.makbuznoshow = false
      this.Bilet.OdemeBilgileri.MakbuzNo = null
      this.Bilet.GenelBilgileri.Referans.Kod = null
      this.Bilet.OdemeBilgileri.SatisSekli = 'K'
      this.bankaposshow = false
      this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
      this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0

    } else if (this.$route.query.isl == 'voidget') {

      var biletparamsvoid = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.$route.query.biletno,
        HavaYoluKodu: this.$route.query.hyolukod,
        UcusTipi: this.$route.query.ucustipi
      }
      this.loadingdialog = true
      this.ucus1 = true
      this.ucus2 = true
      this.ucus3 = true
      this.ucus4 = true
      this.ucus5 = true

      this.$http.post(auth.API_URL + 'api/Ticket/VoidGet', biletparamsvoid, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.guncellebuton = true
        this.baslik_mesaji = "-Bu bilet void olmuştur"
        this.voiddurum = false
        this.voidiptalbtn = true

        var seciliitems = [{
          text: response.body.GenelBilgileri.MusteriKodu.Kod + '-' + response.body.GenelBilgileri.MusteriKodu
            .Unvan,
          id: response.body.GenelBilgileri.MusteriKodu.Kod
        }]

        this.statecari = seciliitems
        this.bekletme = true

        if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
          this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
        }

        this.postaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.TaksitKod
        this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

        this.Bilet = response.body
        this.UcusList = response.body.UcusBilgileri.UcusListesi

        if (response.body.GenelBilgileri.Acente != '' && response.body.GenelBilgileri.Acente != null) {
          this.baslik_mesaji = "(Bu bilet acenteden alınmış ve void olmuştur)"
        } else {
          this.baslik_mesaji = null
        }

        if (this.UcusList.length > 0) {

          var i = 0
          this.UcusList.forEach(element => {

            if (i == 0 && i < this.UcusList.length) {
              this.ucus1 = true
              this.UcusListesi.Ucus1.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus1.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus1.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus1.FareBases = 0
              }

              this.UcusListesi.Ucus1.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus1.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus1.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus1.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus1.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus1.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus1.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus1.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus1.UcusSaat = this.UcusList[i].UcusSaat
              this.UcusListesi.Ucus1.UcusTarihi = this.UcusList[i].UcusTarihi
              this.UcusListesi.Ucus1.VarisSaat = this.UcusList[i].VarisSaat
              this.UcusListesi.Ucus1.VarisTarihi = this.UcusList[i].VarisTarihi
              i = i + 1
            }
            if (i == 1 && i < this.UcusList.length) {
              this.ucus2 = true
              this.UcusListesi.Ucus2.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus2.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus2.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus2.FareBases = 0
              }
              this.UcusListesi.Ucus2.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus2.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus2.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus2.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus2.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus2.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus2.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus2.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus2.UcusSaat = this.UcusList[i].UcusSaat
              this.UcusListesi.Ucus2.UcusTarihi = this.UcusList[i].UcusTarihi
              this.UcusListesi.Ucus2.VarisSaat = this.UcusList[i].VarisSaat
              this.UcusListesi.Ucus2.VarisTarihi = this.UcusList[i].VarisTarihi
              i = i + 1
            }
            if (i == 2 && i < this.UcusList.length) {
              this.ucus3 = true
              this.UcusListesi.Ucus3.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus3.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus3.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus3.FareBases = 0
              }
              this.UcusListesi.Ucus3.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus3.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus3.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus3.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus3.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus3.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus3.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus3.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus3.UcusSaat = this.UcusList[i].UcusSaat
              this.UcusListesi.Ucus3.UcusTarihi = this.UcusList[i].UcusTarihi
              this.UcusListesi.Ucus3.VarisSaat = this.UcusList[i].VarisSaat
              this.UcusListesi.Ucus3.VarisTarihi = this.UcusList[i].VarisTarihi
              i = i + 1
            }

            if (i == 3 && i < this.UcusList.length) {
              this.ucus4 = true
              this.UcusListesi.Ucus4.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus4.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus4.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus4.FareBases = 0
              }
              this.UcusListesi.Ucus4.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus4.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus4.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus4.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus4.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus4.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus4.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus4.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus4.UcusSaat = this.UcusList[i].UcusSaat
              this.UcusListesi.Ucus4.UcusTarihi = this.UcusList[i].UcusTarihi
              this.UcusListesi.Ucus4.VarisSaat = this.UcusList[i].VarisSaat
              this.UcusListesi.Ucus4.VarisTarihi = this.UcusList[i].VarisTarihi
              i = i + 1
            }

            if (i == 4 && i < this.UcusList.length) {
              this.ucus5 = true
              this.UcusListesi.Ucus5.Aktarma = this.UcusList[i].Aktarma
              this.UcusListesi.Ucus5.BiletNo = this.UcusList[i].BiletNo
              if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                this.UcusListesi.Ucus5.FareBases = parseFloat(this.UcusList[i].FareBases)
              } else {
                this.UcusListesi.Ucus5.FareBases = 0
              }
              this.UcusListesi.Ucus5.Formno = this.UcusList[i].Formno
              this.UcusListesi.Ucus5.ID = this.UcusList[i].ID
              this.UcusListesi.Ucus5.Parkur = this.UcusList[i].Parkur
              this.UcusListesi.Ucus5.ParkurNo = this.UcusList[i].ParkurNo
              this.UcusListesi.Ucus5.SirketKodu = this.UcusList[i].SirketKodu
              this.UcusListesi.Ucus5.UcusClass = this.UcusList[i].UcusClass
              this.UcusListesi.Ucus5.UcusHY = this.UcusList[i].UcusHY
              this.UcusListesi.Ucus5.UcusNo = this.UcusList[i].UcusNo
              this.UcusListesi.Ucus5.UcusSaat = this.UcusList[i].UcusSaat
              this.UcusListesi.Ucus5.UcusTarihi = this.UcusList[i].UcusTarihi
              this.UcusListesi.Ucus5.VarisSaat = this.UcusList[i].VarisSaat
              this.UcusListesi.Ucus5.VarisTarihi = this.UcusList[i].VarisTarihi
              i = i + 1
            }
          });
        }
      }, (response) => {
        if (response.status === 0) {
          console.log('')
        } else {
          console.log('')
        }
      })
    }
  }

  function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
  }
</script>
<style>
  .v-input__icon {
    width: 11px !important;
    min-width: 11px !important;
  }
</style>